// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/sub2/data.proto
/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal.js";
import { SubscriptionFeeBillCycle } from "../billing/data.js";
import { Cart } from "../bills/cart.js";
import { Version } from "../common/client.js";
import { Country } from "../common/countries.js";
import { Money } from "../common/currency.js";
import { CurrencyCode } from "../common/currency_codes.js";
import { DateTime, YearMonthDay } from "../common/time.js";
import { HeadlineFeeRateName } from "../feeplans/pricing/headline_fee_rates.js";
import { Mode_Engine } from "../posmodes/modes/model/mode.js";
import { SellerCode } from "../taxinator/service.js";
import { SubscriptionStatus } from "./common.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.sub2.data";
/** Features represents granular features/services that a plan, when subscribed to, provides access to. */
export var Feature;
(function (Feature) {
    Feature[Feature["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** RETAIL - Defines access to Retail product. */
    Feature[Feature["RETAIL"] = 1] = "RETAIL";
    /** RETAIL_RATE - Defines access to a Retail per-location and per-device processing rate. */
    Feature[Feature["RETAIL_RATE"] = 23] = "RETAIL_RATE";
    /** EMPLOYEE_MANAGEMENT - Team Management features. */
    Feature[Feature["EMPLOYEE_MANAGEMENT"] = 4] = "EMPLOYEE_MANAGEMENT";
    Feature[Feature["TEAM_MANAGEMENT_PERMISSION_SETS_BASIC"] = 75] = "TEAM_MANAGEMENT_PERMISSION_SETS_BASIC";
    Feature[Feature["TEAM_MEMBER_ONBOARDING"] = 103] = "TEAM_MEMBER_ONBOARDING";
    /** APPOINTMENTS - Defines access to Appointments product. */
    Feature[Feature["APPOINTMENTS"] = 5] = "APPOINTMENTS";
    /** MARKETING - Customer Engagement (CE) features. */
    Feature[Feature["MARKETING"] = 2] = "MARKETING";
    Feature[Feature["MARKETING_SMS"] = 26] = "MARKETING_SMS";
    /** MARKETING_SMS_PREMIUM - SQ1 only. Same functionality as MARKETING_SMS with higher message limit in SQ1 */
    Feature[Feature["MARKETING_SMS_PREMIUM"] = 203] = "MARKETING_SMS_PREMIUM";
    Feature[Feature["LOYALTY"] = 3] = "LOYALTY";
    Feature[Feature["LOYALTY_INSIGHTS"] = 6] = "LOYALTY_INSIGHTS";
    Feature[Feature["DIRECTORY"] = 7] = "DIRECTORY";
    Feature[Feature["CUSTOMER_DIRECTORY_SMART_DATA"] = 8] = "CUSTOMER_DIRECTORY_SMART_DATA";
    Feature[Feature["FEEDBACK"] = 9] = "FEEDBACK";
    Feature[Feature["MESSAGING"] = 10] = "MESSAGING";
    Feature[Feature["CRM_ACTIVITY_LIST"] = 11] = "CRM_ACTIVITY_LIST";
    Feature[Feature["CRM_AUTO_PAYMENT_ASSIGNMENT"] = 12] = "CRM_AUTO_PAYMENT_ASSIGNMENT";
    Feature[Feature["CRM_INSIGHTS"] = 13] = "CRM_INSIGHTS";
    Feature[Feature["CRM_NOTES"] = 14] = "CRM_NOTES";
    Feature[Feature["CRM_SMART_GROUPS"] = 15] = "CRM_SMART_GROUPS";
    Feature[Feature["CRM_SORTING"] = 16] = "CRM_SORTING";
    Feature[Feature["CRM_LEGACY_SHOW_ALL_PAYMENTS"] = 17] = "CRM_LEGACY_SHOW_ALL_PAYMENTS";
    Feature[Feature["CRM_LEGACY_CONTACT_LOOKUP"] = 18] = "CRM_LEGACY_CONTACT_LOOKUP";
    Feature[Feature["CRM_CUSTOM_ATTRIBUTES"] = 20] = "CRM_CUSTOM_ATTRIBUTES";
    /** ADVANCED_INVENTORY - Inventory Features */
    Feature[Feature["ADVANCED_INVENTORY"] = 19] = "ADVANCED_INVENTORY";
    Feature[Feature["INVENTORY_BUNDLES"] = 86] = "INVENTORY_BUNDLES";
    /** PREMIUM_SUPPORT - Deprecated */
    Feature[Feature["PREMIUM_SUPPORT"] = 21] = "PREMIUM_SUPPORT";
    /** RESTAURANTS - Restaurants features. */
    Feature[Feature["RESTAURANTS"] = 22] = "RESTAURANTS";
    /** SPOS_DEVICE_SETTINGS - SPOS Device Settings features */
    Feature[Feature["SPOS_DEVICE_SETTINGS"] = 24] = "SPOS_DEVICE_SETTINGS";
    /** RETAIL_BASIC - Defines access to free retail features like creating retail device. */
    Feature[Feature["RETAIL_BASIC"] = 25] = "RETAIL_BASIC";
    /** KDS - Defines access to Kitchen Display System product. */
    Feature[Feature["KDS"] = 27] = "KDS";
    /** PAYROLL - Defines access to Payroll product */
    Feature[Feature["PAYROLL"] = 28] = "PAYROLL";
    /** INVOICES_PLUS - Defines access to paid offering for the Invoices product (Invoices Plus) */
    Feature[Feature["INVOICES_PLUS"] = 29] = "INVOICES_PLUS";
    /** APPOINTMENTS_FREE - Appointments product, free version */
    Feature[Feature["APPOINTMENTS_FREE"] = 30] = "APPOINTMENTS_FREE";
    /** APPOINTMENTS_PLUS - Appointments product, plus version */
    Feature[Feature["APPOINTMENTS_PLUS"] = 31] = "APPOINTMENTS_PLUS";
    /** APPOINTMENTS_PREMIUM - Appointments product, premium version */
    Feature[Feature["APPOINTMENTS_PREMIUM"] = 32] = "APPOINTMENTS_PREMIUM";
    /** APPOINTMENTS_RESOURCE_MANAGEMENT - Appointments product: access to managing resources */
    Feature[Feature["APPOINTMENTS_RESOURCE_MANAGEMENT"] = 33] = "APPOINTMENTS_RESOURCE_MANAGEMENT";
    /** COMMISSION_TRACKING - Defines access to employee commission tracking */
    Feature[Feature["COMMISSION_TRACKING"] = 34] = "COMMISSION_TRACKING";
    /** APPOINTMENTS_PROCESSING_TIME - Appointments product: access to processing time in service items */
    Feature[Feature["APPOINTMENTS_PROCESSING_TIME"] = 35] = "APPOINTMENTS_PROCESSING_TIME";
    /** APPOINTMENTS_CLASS_BOOKING - Appointments product: access to class booking */
    Feature[Feature["APPOINTMENTS_CLASS_BOOKING"] = 36] = "APPOINTMENTS_CLASS_BOOKING";
    /** RESTAURANTS_MOBILE - Restaurants Mobile POS features */
    Feature[Feature["RESTAURANTS_MOBILE"] = 37] = "RESTAURANTS_MOBILE";
    /** SHIFTS_SCHEDULING_BASIC - Shifts features */
    Feature[Feature["SHIFTS_SCHEDULING_BASIC"] = 38] = "SHIFTS_SCHEDULING_BASIC";
    Feature[Feature["SHIFTS_TIME_TRACKING_BASIC"] = 39] = "SHIFTS_TIME_TRACKING_BASIC";
    Feature[Feature["SHIFTS_WAGES_BASIC"] = 40] = "SHIFTS_WAGES_BASIC";
    Feature[Feature["SHIFTS_TIPS_BASIC"] = 41] = "SHIFTS_TIPS_BASIC";
    Feature[Feature["SHIFTS_SCHEDULING_ADVANCED"] = 42] = "SHIFTS_SCHEDULING_ADVANCED";
    Feature[Feature["SHIFTS_TIME_TRACKING_ADVANCED"] = 43] = "SHIFTS_TIME_TRACKING_ADVANCED";
    Feature[Feature["SHIFTS_WAGES_ADVANCED"] = 44] = "SHIFTS_WAGES_ADVANCED";
    Feature[Feature["SHIFTS_TIPS_ADVANCED"] = 45] = "SHIFTS_TIPS_ADVANCED";
    Feature[Feature["SHIFTS_COMMISSIONS_ADVANCED"] = 46] = "SHIFTS_COMMISSIONS_ADVANCED";
    /** ECOM_HOSTING_FREE - Legacy testing ecom products */
    Feature[Feature["ECOM_HOSTING_FREE"] = 47] = "ECOM_HOSTING_FREE";
    Feature[Feature["ECOM_HOSTING_PROFESSIONAL"] = 48] = "ECOM_HOSTING_PROFESSIONAL";
    Feature[Feature["ECOM_HOSTING_PERFORMANCE"] = 49] = "ECOM_HOSTING_PERFORMANCE";
    Feature[Feature["ECOM_HOSTING_PREMIUM"] = 50] = "ECOM_HOSTING_PREMIUM";
    /** SHIFTS_SCHEDULING_BASIC_UNLIMITED - Shifts features for ignoring the team member cap with free features */
    Feature[Feature["SHIFTS_SCHEDULING_BASIC_UNLIMITED"] = 51] = "SHIFTS_SCHEDULING_BASIC_UNLIMITED";
    Feature[Feature["SHIFTS_TIME_TRACKING_BASIC_UNLIMITED"] = 52] = "SHIFTS_TIME_TRACKING_BASIC_UNLIMITED";
    Feature[Feature["SHIFTS_WAGES_BASIC_UNLIMITED"] = 53] = "SHIFTS_WAGES_BASIC_UNLIMITED";
    Feature[Feature["SHIFTS_TIPS_BASIC_UNLIMITED"] = 54] = "SHIFTS_TIPS_BASIC_UNLIMITED";
    /** ECOM_PROFESSIONAL - ECOM (Square Online) Base Services/Plans (Q3 2022) */
    Feature[Feature["ECOM_PROFESSIONAL"] = 55] = "ECOM_PROFESSIONAL";
    Feature[Feature["ECOM_PLUS"] = 56] = "ECOM_PLUS";
    Feature[Feature["ECOM_PREMIUM"] = 57] = "ECOM_PREMIUM";
    /** PAYPROD_PRICING_PLAN - PayProd pricing plans (pricingdecider) * */
    Feature[Feature["PAYPROD_PRICING_PLAN"] = 58] = "PAYPROD_PRICING_PLAN";
    /** CORE - Franchise features * */
    Feature[Feature["CORE"] = 59] = "CORE";
    Feature[Feature["WEB_ONLINE_ORDERING"] = 60] = "WEB_ONLINE_ORDERING";
    Feature[Feature["MOBILE_APP"] = 61] = "MOBILE_APP";
    /** ECOM_FREE - ECOM (Square Online) Free Service/Plan (Q1 2023) */
    Feature[Feature["ECOM_FREE"] = 62] = "ECOM_FREE";
    /** COMMS_ANNOUNCEMENTS - Team Communications features */
    Feature[Feature["COMMS_ANNOUNCEMENTS"] = 63] = "COMMS_ANNOUNCEMENTS";
    Feature[Feature["COMMS_ANNOUNCEMENTS_ACK"] = 64] = "COMMS_ANNOUNCEMENTS_ACK";
    Feature[Feature["COMMS_MESSAGES"] = 65] = "COMMS_MESSAGES";
    Feature[Feature["COMMS_MESSAGES_TRANSLATION"] = 66] = "COMMS_MESSAGES_TRANSLATION";
    Feature[Feature["COMMS_TEAM_FILES"] = 67] = "COMMS_TEAM_FILES";
    Feature[Feature["COMMS_MEDIA_RETENTION_UNLIMITED"] = 68] = "COMMS_MEDIA_RETENTION_UNLIMITED";
    Feature[Feature["COMMS_PROFANITY_FILTER"] = 69] = "COMMS_PROFANITY_FILTER";
    Feature[Feature["COMMS_RESERVED_2"] = 70] = "COMMS_RESERVED_2";
    Feature[Feature["COMMS_RESERVED_3"] = 71] = "COMMS_RESERVED_3";
    Feature[Feature["COMMS_RESERVED_4"] = 72] = "COMMS_RESERVED_4";
    Feature[Feature["COMMS_RESERVED_5"] = 73] = "COMMS_RESERVED_5";
    Feature[Feature["COMMS_RESERVED_6"] = 74] = "COMMS_RESERVED_6";
    /** MESSAGES_PLUS - Messages product, plus version */
    Feature[Feature["MESSAGES_PLUS"] = 76] = "MESSAGES_PLUS";
    /**
     * HR_TOOLKIT_BASIC - DEPRECATED
     *
     * @deprecated
     */
    Feature[Feature["HR_TOOLKIT_BASIC"] = 77] = "HR_TOOLKIT_BASIC";
    /** @deprecated */
    Feature[Feature["HR_TOOLKIT_ADVANCED"] = 78] = "HR_TOOLKIT_ADVANCED";
    /** SPOS_AU_EXPERIMENT - SPOS AU Experiment */
    Feature[Feature["SPOS_AU_EXPERIMENT"] = 79] = "SPOS_AU_EXPERIMENT";
    /** SPOS_PAYMENTS_PAYG - SPOS Dual Mode */
    Feature[Feature["SPOS_PAYMENTS_PAYG"] = 80] = "SPOS_PAYMENTS_PAYG";
    Feature[Feature["SPOS_PAYMENTS_S2S"] = 81] = "SPOS_PAYMENTS_S2S";
    Feature[Feature["SPOS_POS"] = 82] = "SPOS_POS";
    /** SPOS_PAYMENTS_PAYG_V3 - SPOS Dual Mode V3 */
    Feature[Feature["SPOS_PAYMENTS_PAYG_V3"] = 90] = "SPOS_PAYMENTS_PAYG_V3";
    Feature[Feature["SPOS_POS_PAYG_V3"] = 91] = "SPOS_POS_PAYG_V3";
    Feature[Feature["SPOS_POS_S2S_V3"] = 92] = "SPOS_POS_S2S_V3";
    /** SPOS_TIERED_V1_PAYG - SPOS Pricing Experiment V1 (tiered) */
    Feature[Feature["SPOS_TIERED_V1_PAYG"] = 98] = "SPOS_TIERED_V1_PAYG";
    Feature[Feature["SPOS_TIERED_V1_S2S"] = 99] = "SPOS_TIERED_V1_S2S";
    /** HR_MANAGER_BASIC - HR Manager features */
    Feature[Feature["HR_MANAGER_BASIC"] = 83] = "HR_MANAGER_BASIC";
    Feature[Feature["HR_MANAGER_ADVANCED"] = 84] = "HR_MANAGER_ADVANCED";
    /** TEAM_MEMBERS - Staff features */
    Feature[Feature["TEAM_MEMBERS"] = 85] = "TEAM_MEMBERS";
    /** FNB_KIOSK - Defines access to Square Kiosk product. */
    Feature[Feature["FNB_KIOSK"] = 87] = "FNB_KIOSK";
    Feature[Feature["DOCUMENT_STORAGE"] = 88] = "DOCUMENT_STORAGE";
    Feature[Feature["RETAIL_PRICING_2023"] = 89] = "RETAIL_PRICING_2023";
    /** RESTAURANTS_FREE - Features for each tiered Restaurants plan */
    Feature[Feature["RESTAURANTS_FREE"] = 93] = "RESTAURANTS_FREE";
    Feature[Feature["RESTAURANTS_PLUS"] = 94] = "RESTAURANTS_PLUS";
    Feature[Feature["RESTAURANTS_PREMIUM"] = 95] = "RESTAURANTS_PREMIUM";
    /** ADDITIONAL_RESTAURANTS_POS - Restaurants feature to unlock usage of additional POS devices */
    Feature[Feature["ADDITIONAL_RESTAURANTS_POS"] = 96] = "ADDITIONAL_RESTAURANTS_POS";
    /** APPOINTMENTS_CUSTOMER_BLOCKING - Appointments product: access to blocking customers from online booking */
    Feature[Feature["APPOINTMENTS_CUSTOMER_BLOCKING"] = 97] = "APPOINTMENTS_CUSTOMER_BLOCKING";
    /** COMBOS - Defines access to item combos */
    Feature[Feature["COMBOS"] = 100] = "COMBOS";
    /** NOTIFY_WHEN_READY - Defines access to notify when ready */
    Feature[Feature["NOTIFY_WHEN_READY"] = 101] = "NOTIFY_WHEN_READY";
    /** APPOINTMENTS_SERVICE_COST - Appointments product: access to service cost for back bar materials */
    Feature[Feature["APPOINTMENTS_SERVICE_COST"] = 102] = "APPOINTMENTS_SERVICE_COST";
    /** APPOINTMENTS_CREDIT_PACKAGE - Appointments product: access to credit packages */
    Feature[Feature["APPOINTMENTS_CREDIT_PACKAGE"] = 104] = "APPOINTMENTS_CREDIT_PACKAGE";
    /** INSTANT_ACCESS - Defines instant access to orders */
    Feature[Feature["INSTANT_ACCESS"] = 105] = "INSTANT_ACCESS";
    /**
     * SQUARE_ONLINE - [DO NO USE] This is a once deleted feature. Adding it back now because
     * we still allow people to create subscriptions that contain this feature
     * in staging, and not having it will cause our feed consumers to fail.
     */
    Feature[Feature["SQUARE_ONLINE"] = 106] = "SQUARE_ONLINE";
    /** ITEM_SPLITS - Defines access to item splits */
    Feature[Feature["ITEM_SPLITS"] = 107] = "ITEM_SPLITS";
    /**
     * EXPAND_FEATURE_SET - DO NOT USE. This feature should only be added to a plan to ensure that
     * its feature set is a superset of another plans, and never for actual feature gating.
     * See https://docs.google.com/document/d/1Ymw6FPPCVK_b58DKb2fNLCfPtqhF8PaT3gHCYwq8l7c/edit?tab=t.0 for details.
     *
     * @deprecated
     */
    Feature[Feature["EXPAND_FEATURE_SET"] = 108] = "EXPAND_FEATURE_SET";
    Feature[Feature["CATALOG_MGMT_CREATE_ITEMS_FROM_PO"] = 109] = "CATALOG_MGMT_CREATE_ITEMS_FROM_PO";
    Feature[Feature["CATALOG_MGMT_CREATE_BUNDLES"] = 110] = "CATALOG_MGMT_CREATE_BUNDLES";
    /**
     * INVENTORY_MGMT - Groups SQ1 inventory management Plus and Premium features, used to gate the whole applet on POS and "Inventory
     * Management" nav item on Dashboard.
     */
    Feature[Feature["INVENTORY_MGMT"] = 111] = "INVENTORY_MGMT";
    Feature[Feature["INVENTORY_MGMT_STOCK_COUNTS"] = 112] = "INVENTORY_MGMT_STOCK_COUNTS";
    Feature[Feature["INVENTORY_MGMT_MANAGE_UNIT_COSTS"] = 113] = "INVENTORY_MGMT_MANAGE_UNIT_COSTS";
    Feature[Feature["INVENTORY_MGMT_PRINT_BARCODE_LABEL"] = 114] = "INVENTORY_MGMT_PRINT_BARCODE_LABEL";
    Feature[Feature["INVENTORY_MGMT_VENDOR_MGMT"] = 115] = "INVENTORY_MGMT_VENDOR_MGMT";
    Feature[Feature["INVENTORY_MGMT_PO_MGMT"] = 116] = "INVENTORY_MGMT_PO_MGMT";
    Feature[Feature["INVENTORY_MGMT_IMPORT_PO"] = 117] = "INVENTORY_MGMT_IMPORT_PO";
    Feature[Feature["INVENTORY_MGMT_PRINT_BARCODE_LABEL_FROM_PO"] = 118] = "INVENTORY_MGMT_PRINT_BARCODE_LABEL_FROM_PO";
    Feature[Feature["INVENTORY_MGMT_TRANSFER_ORDERS"] = 119] = "INVENTORY_MGMT_TRANSFER_ORDERS";
    Feature[Feature["INVENTORY_MGMT_STOCKABLE"] = 120] = "INVENTORY_MGMT_STOCKABLE";
    Feature[Feature["INVENTORY_MGMT_SELLABLE"] = 121] = "INVENTORY_MGMT_SELLABLE";
    Feature[Feature["INVENTORY_STOCK_CONVERSIONS"] = 122] = "INVENTORY_STOCK_CONVERSIONS";
    Feature[Feature["INVENTORY_HISTORY_EDITING"] = 123] = "INVENTORY_HISTORY_EDITING";
    Feature[Feature["INVENTORY_CROSS_LOC"] = 124] = "INVENTORY_CROSS_LOC";
    /**
     * REPORTING_INVENTORY - Groups SQ1 inventory reporting Plus and Premium features, used to gate the "Inventory Reports" nav item on
     * Dashboard.
     */
    Feature[Feature["REPORTING_INVENTORY"] = 125] = "REPORTING_INVENTORY";
    Feature[Feature["REPORTING_COGS"] = 126] = "REPORTING_COGS";
    Feature[Feature["REPORTING_PROJECTED_PROFITS"] = 127] = "REPORTING_PROJECTED_PROFITS";
    Feature[Feature["REPORTING_INVENTORY_BY_CATEGORY"] = 128] = "REPORTING_INVENTORY_BY_CATEGORY";
    Feature[Feature["REPORTING_AGING_INVENTORY"] = 129] = "REPORTING_AGING_INVENTORY";
    Feature[Feature["REPORTING_VENDOR_SALES"] = 130] = "REPORTING_VENDOR_SALES";
    Feature[Feature["COMPLEX_TXN_EXCHANGES"] = 131] = "COMPLEX_TXN_EXCHANGES";
    Feature[Feature["COMPLEX_TXN_UNLINKED_REFUNDS"] = 132] = "COMPLEX_TXN_UNLINKED_REFUNDS";
    Feature[Feature["COMPLEX_TXN_CROSS_LOCATION_RETURNS"] = 133] = "COMPLEX_TXN_CROSS_LOCATION_RETURNS";
    Feature[Feature["CHECKOUT_ID_SCANNING"] = 134] = "CHECKOUT_ID_SCANNING";
    Feature[Feature["ORDER_MGMT_CROSS_LOCATION_FULFILLMENTS"] = 135] = "ORDER_MGMT_CROSS_LOCATION_FULFILLMENTS";
    Feature[Feature["APPOINTMENTS_MULTI_STAFF_RESERVATIONS"] = 136] = "APPOINTMENTS_MULTI_STAFF_RESERVATIONS";
    Feature[Feature["APPOINTMENTS_GOOGLE_CALENDAR_SYNC"] = 137] = "APPOINTMENTS_GOOGLE_CALENDAR_SYNC";
    Feature[Feature["APPOINTMENTS_CONFIRMATIONS"] = 138] = "APPOINTMENTS_CONFIRMATIONS";
    Feature[Feature["APPOINTMENTS_SMS_TEMPLATING"] = 139] = "APPOINTMENTS_SMS_TEMPLATING";
    Feature[Feature["APPOINTMENTS_NO_SHOW_PROTECTION"] = 140] = "APPOINTMENTS_NO_SHOW_PROTECTION";
    Feature[Feature["APPOINTMENTS_DAILY_RESERVATION_LIMIT"] = 141] = "APPOINTMENTS_DAILY_RESERVATION_LIMIT";
    Feature[Feature["APPOINTMENTS_WAITLIST"] = 142] = "APPOINTMENTS_WAITLIST";
    Feature[Feature["APPOINTMENTS_CUSTOMER_FIELDS"] = 143] = "APPOINTMENTS_CUSTOMER_FIELDS";
    Feature[Feature["APPOINTMENTS_REPORTING"] = 144] = "APPOINTMENTS_REPORTING";
    Feature[Feature["APPOINTMENTS_API_WRITES"] = 145] = "APPOINTMENTS_API_WRITES";
    Feature[Feature["FNB_SCAN_TO_PAY"] = 146] = "FNB_SCAN_TO_PAY";
    Feature[Feature["FNB_INSTANT_PAYOUTS"] = 147] = "FNB_INSTANT_PAYOUTS";
    Feature[Feature["FNB_CLOSING_PROCEDURES"] = 148] = "FNB_CLOSING_PROCEDURES";
    Feature[Feature["FNB_CLOSE_OF_DAY_REPORTS"] = 149] = "FNB_CLOSE_OF_DAY_REPORTS";
    Feature[Feature["FNB_LIVE_SALES_REPORTS"] = 150] = "FNB_LIVE_SALES_REPORTS";
    Feature[Feature["FNB_CATEGORY_ROLLUPS"] = 151] = "FNB_CATEGORY_ROLLUPS";
    Feature[Feature["FNB_MENU_REPORTS"] = 152] = "FNB_MENU_REPORTS";
    Feature[Feature["FNB_CHECKS_WEBHOOK_PAID"] = 153] = "FNB_CHECKS_WEBHOOK_PAID";
    Feature[Feature["FNB_ITEMIZATION_FEED"] = 154] = "FNB_ITEMIZATION_FEED";
    Feature[Feature["FNB_KITCHEN_PERFORMANCE_REPORTING"] = 155] = "FNB_KITCHEN_PERFORMANCE_REPORTING";
    Feature[Feature["FNB_INGREDIENT_COST_TRACKING"] = 156] = "FNB_INGREDIENT_COST_TRACKING";
    Feature[Feature["FNB_THIRD_PARTY_ORDER_MANAGEMENT"] = 157] = "FNB_THIRD_PARTY_ORDER_MANAGEMENT";
    Feature[Feature["ORDER_MGMT_NOTIFY_WHEN_READY"] = 158] = "ORDER_MGMT_NOTIFY_WHEN_READY";
    Feature[Feature["ITEM_COMBOS"] = 159] = "ITEM_COMBOS";
    Feature[Feature["FNB_FLOOR_PLAN_CUSTOMIZATION"] = 160] = "FNB_FLOOR_PLAN_CUSTOMIZATION";
    Feature[Feature["FNB_FLOOR_PLAN_DISPLAY_TIME"] = 161] = "FNB_FLOOR_PLAN_DISPLAY_TIME";
    Feature[Feature["FNB_FLOOR_PLAN_COLOR_INDICATORS"] = 162] = "FNB_FLOOR_PLAN_COLOR_INDICATORS";
    Feature[Feature["FNB_REOPEN_CLOSED_CHECKS"] = 163] = "FNB_REOPEN_CLOSED_CHECKS";
    Feature[Feature["FNB_SPLIT_CHECKS"] = 164] = "FNB_SPLIT_CHECKS";
    Feature[Feature["FNB_PRE_AUTH_BAR_TABS"] = 165] = "FNB_PRE_AUTH_BAR_TABS";
    Feature[Feature["FNB_PARTY_SIZE_AUTO_GRATUITY"] = 166] = "FNB_PARTY_SIZE_AUTO_GRATUITY";
    Feature[Feature["FNB_SECTION_SALES_REPORTS"] = 167] = "FNB_SECTION_SALES_REPORTS";
    Feature[Feature["FNB_SEAT_MANAGEMENT"] = 168] = "FNB_SEAT_MANAGEMENT";
    Feature[Feature["FNB_COURSE_MANAGEMENT"] = 169] = "FNB_COURSE_MANAGEMENT";
    Feature[Feature["FNB_RESERVATIONS"] = 170] = "FNB_RESERVATIONS";
    Feature[Feature["INVOICES_MULTIPLE_INVOICE_TEMPLATES"] = 171] = "INVOICES_MULTIPLE_INVOICE_TEMPLATES";
    Feature[Feature["INVOICES_BATCH_INVOICE_CREATION"] = 172] = "INVOICES_BATCH_INVOICE_CREATION";
    Feature[Feature["INVOICES_ADVANCED_INVOICE_FEATURES"] = 173] = "INVOICES_ADVANCED_INVOICE_FEATURES";
    Feature[Feature["INVOICES_ADVANCED_ESTIMATE_FEATURES"] = 174] = "INVOICES_ADVANCED_ESTIMATE_FEATURES";
    Feature[Feature["INVOICES_CUSTOMIZATION_SETTINGS"] = 175] = "INVOICES_CUSTOMIZATION_SETTINGS";
    Feature[Feature["INVOICES_REDUCED_PROCESSING_FEES"] = 202] = "INVOICES_REDUCED_PROCESSING_FEES";
    Feature[Feature["INVOICES_REDUCED_PROCESSING_FEES_NO_ACH_FEE"] = 218] = "INVOICES_REDUCED_PROCESSING_FEES_NO_ACH_FEE";
    Feature[Feature["INVOICES_PAYMENT_SCHEDULES_UPSELL"] = 207] = "INVOICES_PAYMENT_SCHEDULES_UPSELL";
    Feature[Feature["INVOICES_REQUIRE_CONTRACT_SIGNATURE_UPSELL"] = 208] = "INVOICES_REQUIRE_CONTRACT_SIGNATURE_UPSELL";
    Feature[Feature["INVOICES_CUSTOM_FIELDS_UPSELL"] = 209] = "INVOICES_CUSTOM_FIELDS_UPSELL";
    Feature[Feature["ESTIMATES_MULTIPACKAGE_UPSELL"] = 210] = "ESTIMATES_MULTIPACKAGE_UPSELL";
    Feature[Feature["ESTIMATES_AUTOCONVERT_TO_INVOICE_UPSELL"] = 211] = "ESTIMATES_AUTOCONVERT_TO_INVOICE_UPSELL";
    Feature[Feature["CONTRACTS_DYNAMIC_BUYER_FIELDS"] = 176] = "CONTRACTS_DYNAMIC_BUYER_FIELDS";
    Feature[Feature["STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS"] = 177] = "STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS";
    Feature[Feature["STAFF_TEAM_MEMBER_BADGES"] = 178] = "STAFF_TEAM_MEMBER_BADGES";
    Feature[Feature["STAFF_TIMECARDS"] = 179] = "STAFF_TIMECARDS";
    Feature[Feature["STAFF_SCHEDULING"] = 180] = "STAFF_SCHEDULING";
    Feature[Feature["STAFF_MESSAGES"] = 181] = "STAFF_MESSAGES";
    Feature[Feature["STAFF_TEAM_FILES"] = 182] = "STAFF_TEAM_FILES";
    Feature[Feature["STAFF_ANNOUNCEMENTS"] = 183] = "STAFF_ANNOUNCEMENTS";
    Feature[Feature["STAFF_ADVANCED_TIP_TRACKING"] = 184] = "STAFF_ADVANCED_TIP_TRACKING";
    Feature[Feature["STAFF_COMMISSION_TRACKING"] = 185] = "STAFF_COMMISSION_TRACKING";
    Feature[Feature["STAFF_SALES_BY_TEAM_MEMBER"] = 186] = "STAFF_SALES_BY_TEAM_MEMBER";
    Feature[Feature["STAFF_LABOR_VS_SALES_REPORT"] = 187] = "STAFF_LABOR_VS_SALES_REPORT";
    Feature[Feature["STAFF_ACTIVITY_LOG_BY_TEAM_MEMBER"] = 188] = "STAFF_ACTIVITY_LOG_BY_TEAM_MEMBER";
    Feature[Feature["STAFF_TEAM_MEMBER_DOCUMENTS"] = 189] = "STAFF_TEAM_MEMBER_DOCUMENTS";
    Feature[Feature["STAFF_NEW_HIRE_ONBOARDING"] = 190] = "STAFF_NEW_HIRE_ONBOARDING";
    Feature[Feature["SQUARE_ONE"] = 191] = "SQUARE_ONE";
    Feature[Feature["INVENTORY_MGMT_PENDING_RESTOCKS"] = 192] = "INVENTORY_MGMT_PENDING_RESTOCKS";
    Feature[Feature["INVENTORY_MGMT_INVENTORY_HISTORY"] = 193] = "INVENTORY_MGMT_INVENTORY_HISTORY";
    Feature[Feature["INVENTORY_MGMT_QUICK_RECEIVE_VIA_SCAN"] = 194] = "INVENTORY_MGMT_QUICK_RECEIVE_VIA_SCAN";
    Feature[Feature["INVENTORY_MGMT_BULK_INVENTORY_RECEIVE"] = 195] = "INVENTORY_MGMT_BULK_INVENTORY_RECEIVE";
    Feature[Feature["REPORTING_INVENTORY_SELL_THROUGH"] = 196] = "REPORTING_INVENTORY_SELL_THROUGH";
    Feature[Feature["REPORTING_STOCK_OVERVIEW"] = 197] = "REPORTING_STOCK_OVERVIEW";
    Feature[Feature["FNB_RECIPES"] = 198] = "FNB_RECIPES";
    /** SQ1_ONLINE_FREE - Includes all Square Online features contained in SQ1 Free */
    Feature[Feature["SQ1_ONLINE_FREE"] = 199] = "SQ1_ONLINE_FREE";
    /** SQ1_ONLINE_PLUS - Includes all Square Online features contained in SQ1 Plus */
    Feature[Feature["SQ1_ONLINE_PLUS"] = 200] = "SQ1_ONLINE_PLUS";
    /** SQ1_ONLINE_PREMIUM - Includes all Square Online features contained in SQ1 Premium */
    Feature[Feature["SQ1_ONLINE_PREMIUM"] = 201] = "SQ1_ONLINE_PREMIUM";
    Feature[Feature["PHONE_SUPPORT_STANDARD"] = 204] = "PHONE_SUPPORT_STANDARD";
    Feature[Feature["PHONE_SUPPORT_PRIORITY"] = 205] = "PHONE_SUPPORT_PRIORITY";
    Feature[Feature["PHONE_SUPPORT_CONCIERGE"] = 206] = "PHONE_SUPPORT_CONCIERGE";
    /** SQUARE_ONE_FREE - WARNING: Please reach out to the SaaS team before relying on this feature. */
    Feature[Feature["SQUARE_ONE_FREE"] = 212] = "SQUARE_ONE_FREE";
    /** SQUARE_ONE_PLUS - WARNING: Please reach out to the SaaS team before relying on this feature. */
    Feature[Feature["SQUARE_ONE_PLUS"] = 213] = "SQUARE_ONE_PLUS";
    /** SQUARE_ONE_PREMIUM - WARNING: Please reach out to the SaaS team before relying on this feature. */
    Feature[Feature["SQUARE_ONE_PREMIUM"] = 214] = "SQUARE_ONE_PREMIUM";
    Feature[Feature["FNB_SHIFT_REPORTS"] = 215] = "FNB_SHIFT_REPORTS";
    Feature[Feature["RESTAURANTS_POS_FREE_FEEPLAN"] = 216] = "RESTAURANTS_POS_FREE_FEEPLAN";
    Feature[Feature["RESTAURANTS_POS_PAID_FEEPLAN"] = 217] = "RESTAURANTS_POS_PAID_FEEPLAN";
    /** PHONE_SUPPORT_PLAN - Marker feature to identify phone support plans */
    Feature[Feature["PHONE_SUPPORT_PLAN"] = 219] = "PHONE_SUPPORT_PLAN";
    /** GSO_PAYMENT_PLAN - Marker feature to identify GSO payment plans */
    Feature[Feature["GSO_PAYMENT_PLAN"] = 220] = "GSO_PAYMENT_PLAN";
    Feature[Feature["LOCATION_GROUPS_MANAGEMENT"] = 221] = "LOCATION_GROUPS_MANAGEMENT";
})(Feature || (Feature = {}));
export var PlanSetting;
(function (PlanSetting) {
    PlanSetting[PlanSetting["PLAN_SETTING_DO_NOT_USE"] = 0] = "PLAN_SETTING_DO_NOT_USE";
    PlanSetting[PlanSetting["ALLOWED"] = 1] = "ALLOWED";
    PlanSetting[PlanSetting["NOT_ALLOWED"] = 2] = "NOT_ALLOWED";
    PlanSetting[PlanSetting["CONFIGURABLE"] = 3] = "CONFIGURABLE";
})(PlanSetting || (PlanSetting = {}));
export var MigrationStatus;
(function (MigrationStatus) {
    MigrationStatus[MigrationStatus["SUCCESS"] = 1] = "SUCCESS";
    MigrationStatus[MigrationStatus["FAILURE"] = 2] = "FAILURE";
})(MigrationStatus || (MigrationStatus = {}));
/** The type of unit for usage/pricing. For example, employee, register device, etc. */
export var UsageUnitType;
(function (UsageUnitType) {
    UsageUnitType[UsageUnitType["INVALID"] = 0] = "INVALID";
    /** @deprecated */
    UsageUnitType[UsageUnitType["EMPLOYEE"] = 1] = "EMPLOYEE";
    /** @deprecated */
    UsageUnitType[UsageUnitType["RETAIL_DEVICE"] = 2] = "RETAIL_DEVICE";
    UsageUnitType[UsageUnitType["CUSTOMER"] = 3] = "CUSTOMER";
    UsageUnitType[UsageUnitType["APPOINTMENTS_EMPLOYEE"] = 4] = "APPOINTMENTS_EMPLOYEE";
    UsageUnitType[UsageUnitType["RESTAURANTS_LOCATION"] = 5] = "RESTAURANTS_LOCATION";
    UsageUnitType[UsageUnitType["RESTAURANTS_ADDITIONAL_DEVICE"] = 6] = "RESTAURANTS_ADDITIONAL_DEVICE";
    UsageUnitType[UsageUnitType["RETAIL_LOCATION"] = 7] = "RETAIL_LOCATION";
    /**
     * RETAIL_ADDITIONAL_DEVICE - TODO(RETAIL-8441): Remove this UsageUnitType after ce-subs is updated
     *
     * @deprecated
     */
    UsageUnitType[UsageUnitType["RETAIL_ADDITIONAL_DEVICE"] = 8] = "RETAIL_ADDITIONAL_DEVICE";
    UsageUnitType[UsageUnitType["EMPLOYEE_MANAGEMENT_LOCATION"] = 9] = "EMPLOYEE_MANAGEMENT_LOCATION";
    UsageUnitType[UsageUnitType["SPOS_DEVICE_SETTINGS_DEVICE"] = 10] = "SPOS_DEVICE_SETTINGS_DEVICE";
    UsageUnitType[UsageUnitType["REACHABLE_CONTACTS"] = 11] = "REACHABLE_CONTACTS";
    UsageUnitType[UsageUnitType["LOYALTY_LOCATIONS"] = 12] = "LOYALTY_LOCATIONS";
    UsageUnitType[UsageUnitType["LOYALTY_TRANSACTIONS"] = 13] = "LOYALTY_TRANSACTIONS";
    UsageUnitType[UsageUnitType["LOYALTY_TRANSACTIONS_TIER"] = 14] = "LOYALTY_TRANSACTIONS_TIER";
    UsageUnitType[UsageUnitType["PAYROLL_EMPLOYEE"] = 15] = "PAYROLL_EMPLOYEE";
    UsageUnitType[UsageUnitType["PAYROLL_W2_EMPLOYER"] = 16] = "PAYROLL_W2_EMPLOYER";
    UsageUnitType[UsageUnitType["MARKETING_SMS_MESSAGES"] = 17] = "MARKETING_SMS_MESSAGES";
    UsageUnitType[UsageUnitType["LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1"] = 18] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1";
    UsageUnitType[UsageUnitType["LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2"] = 19] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2";
    UsageUnitType[UsageUnitType["LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3"] = 20] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3";
    UsageUnitType[UsageUnitType["KDS_DEVICE"] = 21] = "KDS_DEVICE";
    UsageUnitType[UsageUnitType["APPOINTMENTS_LOCATIONS"] = 22] = "APPOINTMENTS_LOCATIONS";
    UsageUnitType[UsageUnitType["RESTAURANTS_MOBILE_LOCATION"] = 23] = "RESTAURANTS_MOBILE_LOCATION";
    UsageUnitType[UsageUnitType["SHIFTS_TEAM_MEMBER"] = 24] = "SHIFTS_TEAM_MEMBER";
    /**
     * ECOM_SITES - not used, SO site level pricing is not supported
     *
     * @deprecated
     */
    UsageUnitType[UsageUnitType["ECOM_SITES"] = 25] = "ECOM_SITES";
    /**
     * ECOM_ACCOUNT - not used, SO plans should just use fixed pricing
     *
     * @deprecated
     */
    UsageUnitType[UsageUnitType["ECOM_ACCOUNT"] = 26] = "ECOM_ACCOUNT";
    /**
     * MARKETING_MMS_MESSAGES - not used
     *
     * @deprecated
     */
    UsageUnitType[UsageUnitType["MARKETING_MMS_MESSAGES"] = 27] = "MARKETING_MMS_MESSAGES";
    UsageUnitType[UsageUnitType["COMMS_TEAM_MEMBER"] = 28] = "COMMS_TEAM_MEMBER";
    UsageUnitType[UsageUnitType["MESSAGES_LOCATION"] = 29] = "MESSAGES_LOCATION";
    /** @deprecated */
    UsageUnitType[UsageUnitType["HR_TOOLKIT_EMPLOYEE"] = 30] = "HR_TOOLKIT_EMPLOYEE";
    /** @deprecated */
    UsageUnitType[UsageUnitType["HR_MANAGER_EMPLOYEE"] = 31] = "HR_MANAGER_EMPLOYEE";
    UsageUnitType[UsageUnitType["STAFF_TEAM_MEMBER"] = 32] = "STAFF_TEAM_MEMBER";
    UsageUnitType[UsageUnitType["HR_MANAGER_TEAM_MEMBER"] = 33] = "HR_MANAGER_TEAM_MEMBER";
    UsageUnitType[UsageUnitType["PAYROLL_MAILED_TAX_FORM"] = 34] = "PAYROLL_MAILED_TAX_FORM";
    UsageUnitType[UsageUnitType["STAFF_LOCATION"] = 35] = "STAFF_LOCATION";
    UsageUnitType[UsageUnitType["FNB_KIOSK_DEVICE"] = 36] = "FNB_KIOSK_DEVICE";
    UsageUnitType[UsageUnitType["COMBOS_LOCATION"] = 37] = "COMBOS_LOCATION";
    UsageUnitType[UsageUnitType["FRANCHISE_LOCATION"] = 38] = "FRANCHISE_LOCATION";
    UsageUnitType[UsageUnitType["RESTAURANTS_MOBILE_DEVICE"] = 39] = "RESTAURANTS_MOBILE_DEVICE";
    UsageUnitType[UsageUnitType["LOYALTY_PAYG_USAGE"] = 40] = "LOYALTY_PAYG_USAGE";
    UsageUnitType[UsageUnitType["LOYALTY_PAYG_LOCATION"] = 41] = "LOYALTY_PAYG_LOCATION";
    UsageUnitType[UsageUnitType["BILLABLE_LOCATION"] = 42] = "BILLABLE_LOCATION";
})(UsageUnitType || (UsageUnitType = {}));
export var ManagedBy;
(function (ManagedBy) {
    /** UNKNOWN - Do not use */
    ManagedBy[ManagedBy["UNKNOWN"] = 0] = "UNKNOWN";
    /** SQUARE - Managed by traditional Square SaaS flows */
    ManagedBy[ManagedBy["SQUARE"] = 1] = "SQUARE";
    /** APPLE - Managed by the App Store via external-subs service */
    ManagedBy[ManagedBy["APPLE"] = 2] = "APPLE";
    /** GOOGLE - Managed by Google Play via external-subs service */
    ManagedBy[ManagedBy["GOOGLE"] = 3] = "GOOGLE";
})(ManagedBy || (ManagedBy = {}));
export var DisplayedFeatureName;
(function (DisplayedFeatureName) {
    DisplayedFeatureName[DisplayedFeatureName["DO_NOT_USE_THIS"] = 0] = "DO_NOT_USE_THIS";
    DisplayedFeatureName[DisplayedFeatureName["LOWER_PROCESSING"] = 1] = "LOWER_PROCESSING";
    DisplayedFeatureName[DisplayedFeatureName["UNLIMITED_TIME_TRACKING"] = 2] = "UNLIMITED_TIME_TRACKING";
    DisplayedFeatureName[DisplayedFeatureName["LABEL_PRINTING"] = 3] = "LABEL_PRINTING";
    DisplayedFeatureName[DisplayedFeatureName["ADVANCED_INVENTORY_MANAGEMENT"] = 4] = "ADVANCED_INVENTORY_MANAGEMENT";
    DisplayedFeatureName[DisplayedFeatureName["REPORTING"] = 5] = "REPORTING";
})(DisplayedFeatureName || (DisplayedFeatureName = {}));
export var SquareOneMigrationStatus;
(function (SquareOneMigrationStatus) {
    SquareOneMigrationStatus[SquareOneMigrationStatus["DO_NOT_USE_MIGRATION_STATUS"] = 0] = "DO_NOT_USE_MIGRATION_STATUS";
    /** OPTED_IN - The seller has opted into the migration program. */
    SquareOneMigrationStatus[SquareOneMigrationStatus["OPTED_IN"] = 1] = "OPTED_IN";
    /** OPTED_OUT - The seller has opted out of the migration program. */
    SquareOneMigrationStatus[SquareOneMigrationStatus["OPTED_OUT"] = 2] = "OPTED_OUT";
})(SquareOneMigrationStatus || (SquareOneMigrationStatus = {}));
export var MigrationOutcome;
(function (MigrationOutcome) {
    /** MIGRATION_OUTCOME_UNSPECIFIED - Default value, not specified */
    MigrationOutcome[MigrationOutcome["MIGRATION_OUTCOME_UNSPECIFIED"] = 0] = "MIGRATION_OUTCOME_UNSPECIFIED";
    /** MIGRATED_VIA_OPT_IN - User opted in to the migration experiment */
    MigrationOutcome[MigrationOutcome["MIGRATED_VIA_OPT_IN"] = 1] = "MIGRATED_VIA_OPT_IN";
    /** MIGRATED_VIA_REGULATOR - User was migrated via regulator */
    MigrationOutcome[MigrationOutcome["MIGRATED_VIA_REGULATOR"] = 2] = "MIGRATED_VIA_REGULATOR";
    /** MIGRATED_VIA_NO_OPT_OUT - User did nothing in an AUTO_MIGRATE experiment and was migrated automatically */
    MigrationOutcome[MigrationOutcome["MIGRATED_VIA_NO_OPT_OUT"] = 3] = "MIGRATED_VIA_NO_OPT_OUT";
    /** NOT_MIGRATED_DUE_TO_OPT_OUT - User explicitly opted out of the migration in a AUTO_MIGRATE experiment */
    MigrationOutcome[MigrationOutcome["NOT_MIGRATED_DUE_TO_OPT_OUT"] = 4] = "NOT_MIGRATED_DUE_TO_OPT_OUT";
    /** NOT_MIGRATED_DUE_TO_INELIGIBILITY - User become ineligible while enrolled in the experiment due to changes in their subscription statuses */
    MigrationOutcome[MigrationOutcome["NOT_MIGRATED_DUE_TO_INELIGIBILITY"] = 5] = "NOT_MIGRATED_DUE_TO_INELIGIBILITY";
    /** NOT_MIGRATED_DUE_TO_NO_OPT_IN - User did not opt in for the migration in a OPTED_IN experiment */
    MigrationOutcome[MigrationOutcome["NOT_MIGRATED_DUE_TO_NO_OPT_IN"] = 6] = "NOT_MIGRATED_DUE_TO_NO_OPT_IN";
    /** ALREADY_SUBSCRIBED - User was already subscribed outside of the experiment window */
    MigrationOutcome[MigrationOutcome["ALREADY_SUBSCRIBED"] = 7] = "ALREADY_SUBSCRIBED";
    /** MIGRATING - a transient status indicating the migration is happening */
    MigrationOutcome[MigrationOutcome["MIGRATING"] = 8] = "MIGRATING";
})(MigrationOutcome || (MigrationOutcome = {}));
/** MigrateToSquareOneTiming defines when the Square One migration should happen. */
export var MigrateToSquareOneTiming;
(function (MigrateToSquareOneTiming) {
    MigrateToSquareOneTiming[MigrateToSquareOneTiming["MIGRATE_TIMING_DO_NOT_USE"] = 0] = "MIGRATE_TIMING_DO_NOT_USE";
    /** IMMEDIATE - The migration should happen immediately. */
    MigrateToSquareOneTiming[MigrateToSquareOneTiming["IMMEDIATE"] = 1] = "IMMEDIATE";
    /** OFF_HOURS - The migration should be scheduled for the next off-hours window. */
    MigrateToSquareOneTiming[MigrateToSquareOneTiming["OFF_HOURS"] = 2] = "OFF_HOURS";
})(MigrateToSquareOneTiming || (MigrateToSquareOneTiming = {}));
/** Type of the token used to represent the entity. */
export var Entity_TokenType;
(function (Entity_TokenType) {
    Entity_TokenType[Entity_TokenType["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** INTERNAL - Type for tokens generated internally in Subscriptions. */
    Entity_TokenType[Entity_TokenType["INTERNAL"] = 1] = "INTERNAL";
    /** MERCHANT - Merchant tokens from User table in sq/web. */
    Entity_TokenType[Entity_TokenType["MERCHANT"] = 2] = "MERCHANT";
    /** PERSON - Person tokens from Person service. */
    Entity_TokenType[Entity_TokenType["PERSON"] = 3] = "PERSON";
    /** MERCHANT_CONTACT - Merchant contact tokens from Rolodex service. */
    Entity_TokenType[Entity_TokenType["MERCHANT_CONTACT"] = 4] = "MERCHANT_CONTACT";
    /** REGISTRY_UID - Registry UID for ids from the Registry for square employees. */
    Entity_TokenType[Entity_TokenType["REGISTRY_UID"] = 5] = "REGISTRY_UID";
})(Entity_TokenType || (Entity_TokenType = {}));
/** Enum representing the type of the product owner entity. */
export var ProductOwner_OwnerType;
(function (ProductOwner_OwnerType) {
    ProductOwner_OwnerType[ProductOwner_OwnerType["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** SQUARE - Square as product owner. */
    ProductOwner_OwnerType[ProductOwner_OwnerType["SQUARE"] = 1] = "SQUARE";
    /** APP_MARKETPLACE - For partners (like FreshKDS, TaxJar, etc.) as product owner. */
    ProductOwner_OwnerType[ProductOwner_OwnerType["APP_MARKETPLACE"] = 2] = "APP_MARKETPLACE";
    /** MERCHANT - For external merchant as product owner. */
    ProductOwner_OwnerType[ProductOwner_OwnerType["MERCHANT"] = 3] = "MERCHANT";
})(ProductOwner_OwnerType || (ProductOwner_OwnerType = {}));
/** Type of plans offered within this product: pre-pay or post-pay. */
export var Product_PayType;
(function (Product_PayType) {
    Product_PayType[Product_PayType["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    Product_PayType[Product_PayType["PRE_PAY"] = 1] = "PRE_PAY";
    Product_PayType[Product_PayType["POST_PAY"] = 2] = "POST_PAY";
})(Product_PayType || (Product_PayType = {}));
export var Duration_DurationUnit;
(function (Duration_DurationUnit) {
    Duration_DurationUnit[Duration_DurationUnit["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    Duration_DurationUnit[Duration_DurationUnit["DAY"] = 1] = "DAY";
    Duration_DurationUnit[Duration_DurationUnit["MONTH"] = 2] = "MONTH";
    Duration_DurationUnit[Duration_DurationUnit["YEAR"] = 3] = "YEAR";
})(Duration_DurationUnit || (Duration_DurationUnit = {}));
/** AvailabilityStatus defines the various plan availability statuses. */
export var Plan_AvailabilityStatus;
(function (Plan_AvailabilityStatus) {
    Plan_AvailabilityStatus[Plan_AvailabilityStatus["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** AVAILABLE - The plan is generally available for sign ups. */
    Plan_AvailabilityStatus[Plan_AvailabilityStatus["AVAILABLE"] = 1] = "AVAILABLE";
    /** DEPRECATED - No new sign ups, but existing subscriptions can continue to be on the plan. */
    Plan_AvailabilityStatus[Plan_AvailabilityStatus["DEPRECATED"] = 2] = "DEPRECATED";
    /** DELETED - No subscription can be on a deleted plan. */
    Plan_AvailabilityStatus[Plan_AvailabilityStatus["DELETED"] = 3] = "DELETED";
})(Plan_AvailabilityStatus || (Plan_AvailabilityStatus = {}));
/**
 * Assuming that we have a product X and the tiers are (based on unit counts):
 * 1. 0-50
 * 2. >= 51
 */
export var TieredPricing_Calculation;
(function (TieredPricing_Calculation) {
    /**
     * FIXED - (DEFAULT) Fixed charges for different tiers.
     * Eg. when tier 1 is 25$ and tier 2 is 50$:
     * Cost(75*X) = 50
     * Cost(51*X) = 50
     * Cost(49*X) = 25
     */
    TieredPricing_Calculation[TieredPricing_Calculation["FIXED"] = 0] = "FIXED";
    /**
     * BULK - Once reaching the "threshold" for a new tier, the cost per unit will change.
     * Eg. when tier 1 is 2.5$ per unit and tier 2 is 2$ per unit:
     * Cost(75*X) = 2 * 75
     * Cost(51*X) = 2 * 51
     * Cost(49*X) = 2.5 * 75
     */
    TieredPricing_Calculation[TieredPricing_Calculation["BULK"] = 1] = "BULK";
    /**
     * USAGE - Different costs per unit for different tiers.
     * Eg. when tier 1 is 2.5$ per unit and tier 2 is 2$ per unit:
     * Cost(75*X) = 2.5 * 50 + 2 * 25
     * Cost(51*X) = 2.5 * 50 + 2 * 1
     * Cost(49*X)  = 2.5 * 49
     */
    TieredPricing_Calculation[TieredPricing_Calculation["USAGE"] = 2] = "USAGE";
})(TieredPricing_Calculation || (TieredPricing_Calculation = {}));
/** BillingStatus describes the status of the subscription's billing/charges. */
export var Subscription_BillingStatus;
(function (Subscription_BillingStatus) {
    /** NONE - No status available. This is the default. */
    Subscription_BillingStatus[Subscription_BillingStatus["NONE"] = 0] = "NONE";
    /** BILLED - Subscription was billed for charge(s) but the success/failure of that is unavailable. */
    Subscription_BillingStatus[Subscription_BillingStatus["BILLED"] = 1] = "BILLED";
    /** PAID - All charges for the subscription are currently paid and there are no pending charges. */
    Subscription_BillingStatus[Subscription_BillingStatus["PAID"] = 2] = "PAID";
    /** FAILED - Some of the subscription charges are unpaid and past due. */
    Subscription_BillingStatus[Subscription_BillingStatus["FAILED"] = 3] = "FAILED";
    /** LAPSED - Some of the subscription charges are unpaid and past due and we have given up on collection. */
    Subscription_BillingStatus[Subscription_BillingStatus["LAPSED"] = 4] = "LAPSED";
})(Subscription_BillingStatus || (Subscription_BillingStatus = {}));
export var Charge_ChargeStatus;
(function (Charge_ChargeStatus) {
    /** DO_NOT_USE - Do not use */
    Charge_ChargeStatus[Charge_ChargeStatus["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** CHARGED - Charged charge */
    Charge_ChargeStatus[Charge_ChargeStatus["CHARGED"] = 1] = "CHARGED";
    /** PAID - Paid charge */
    Charge_ChargeStatus[Charge_ChargeStatus["PAID"] = 2] = "PAID";
    /** FAILED - Failed charge */
    Charge_ChargeStatus[Charge_ChargeStatus["FAILED"] = 3] = "FAILED";
    /** REFUNDED - Refunded charge */
    Charge_ChargeStatus[Charge_ChargeStatus["REFUNDED"] = 4] = "REFUNDED";
    /** DISPUTED - Disputed charge */
    Charge_ChargeStatus[Charge_ChargeStatus["DISPUTED"] = 5] = "DISPUTED";
    /** VOIDED - Voided charge */
    Charge_ChargeStatus[Charge_ChargeStatus["VOIDED"] = 6] = "VOIDED";
})(Charge_ChargeStatus || (Charge_ChargeStatus = {}));
export var UnavailableReason_UnavailableReasonCode;
(function (UnavailableReason_UnavailableReasonCode) {
    UnavailableReason_UnavailableReasonCode[UnavailableReason_UnavailableReasonCode["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** RULE - Blocked by a plan rule */
    UnavailableReason_UnavailableReasonCode[UnavailableReason_UnavailableReasonCode["RULE"] = 1] = "RULE";
    /** UNSUPPORTED - Invalid operation */
    UnavailableReason_UnavailableReasonCode[UnavailableReason_UnavailableReasonCode["UNSUPPORTED"] = 2] = "UNSUPPORTED";
})(UnavailableReason_UnavailableReasonCode || (UnavailableReason_UnavailableReasonCode = {}));
export var BaseRate_FeeRateConstraint_Type;
(function (BaseRate_FeeRateConstraint_Type) {
    /** DO_NOT_USE - Do not use. */
    BaseRate_FeeRateConstraint_Type[BaseRate_FeeRateConstraint_Type["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /**
     * MIN_FEE - Sets the amount_base_units in the constraint to be the minimum
     * fee to be charged, regardless of the transaction amount
     */
    BaseRate_FeeRateConstraint_Type[BaseRate_FeeRateConstraint_Type["MIN_FEE"] = 1] = "MIN_FEE";
    /**
     * MAX_FEE - Sets the amount_base_units in the constraint to be the maximum
     * fee to be charged, regardless of the transaction amount
     */
    BaseRate_FeeRateConstraint_Type[BaseRate_FeeRateConstraint_Type["MAX_FEE"] = 2] = "MAX_FEE";
})(BaseRate_FeeRateConstraint_Type || (BaseRate_FeeRateConstraint_Type = {}));
/** The parts of a plan to apply the discount to. */
export var PercentDiscountBundlePriceAdjustment_DiscountedComponentType;
(function (PercentDiscountBundlePriceAdjustment_DiscountedComponentType) {
    PercentDiscountBundlePriceAdjustment_DiscountedComponentType[PercentDiscountBundlePriceAdjustment_DiscountedComponentType["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** BASE_FEE_ONLY - The discount is applied only to base fees/fixed costs. Usage is not discounted. */
    PercentDiscountBundlePriceAdjustment_DiscountedComponentType[PercentDiscountBundlePriceAdjustment_DiscountedComponentType["BASE_FEE_ONLY"] = 1] = "BASE_FEE_ONLY";
    /** USAGES_ONLY - Usage charges are discounted. Any base fees or fixed costs are not. */
    PercentDiscountBundlePriceAdjustment_DiscountedComponentType[PercentDiscountBundlePriceAdjustment_DiscountedComponentType["USAGES_ONLY"] = 2] = "USAGES_ONLY";
    /** BASE_FEE_AND_USAGES - The total charge for the subscription is discounted. */
    PercentDiscountBundlePriceAdjustment_DiscountedComponentType[PercentDiscountBundlePriceAdjustment_DiscountedComponentType["BASE_FEE_AND_USAGES"] = 3] = "BASE_FEE_AND_USAGES";
})(PercentDiscountBundlePriceAdjustment_DiscountedComponentType || (PercentDiscountBundlePriceAdjustment_DiscountedComponentType = {}));
/** AvailabilityStatus defines the various bundle offering availability statuses. */
export var BundleOffering_AvailabilityStatus;
(function (BundleOffering_AvailabilityStatus) {
    BundleOffering_AvailabilityStatus[BundleOffering_AvailabilityStatus["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** ACTIVE - The bundle offering is generally available for sign ups. */
    BundleOffering_AvailabilityStatus[BundleOffering_AvailabilityStatus["ACTIVE"] = 1] = "ACTIVE";
    /** DISABLED - No new sign ups, but existing users can continue to be on the bundle offering. */
    BundleOffering_AvailabilityStatus[BundleOffering_AvailabilityStatus["DISABLED"] = 2] = "DISABLED";
})(BundleOffering_AvailabilityStatus || (BundleOffering_AvailabilityStatus = {}));
export var FeedbackOption_InputType;
(function (FeedbackOption_InputType) {
    FeedbackOption_InputType[FeedbackOption_InputType["INPUT_TYPE_DO_NOT_USE"] = 0] = "INPUT_TYPE_DO_NOT_USE";
    FeedbackOption_InputType[FeedbackOption_InputType["SELECT"] = 1] = "SELECT";
    FeedbackOption_InputType[FeedbackOption_InputType["MULTISELECT"] = 2] = "MULTISELECT";
    FeedbackOption_InputType[FeedbackOption_InputType["TEXT"] = 3] = "TEXT";
})(FeedbackOption_InputType || (FeedbackOption_InputType = {}));
export var SquareOneEligibility_IneligibilityReason;
(function (SquareOneEligibility_IneligibilityReason) {
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** FEATURE_FLAG - The seller is ineligible because of experiment bucketing. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["FEATURE_FLAG"] = 1] = "FEATURE_FLAG";
    /** HAS_LEGACY_SUBSCRIPTIONS - The seller is ineligible because they have incompatible legacy subscriptions. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["HAS_LEGACY_SUBSCRIPTIONS"] = 2] = "HAS_LEGACY_SUBSCRIPTIONS";
    /** MERCHANT_CREATION_DATE - The seller is ineligible because they are not net new. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["MERCHANT_CREATION_DATE"] = 3] = "MERCHANT_CREATION_DATE";
    /** MERCHANT_COUNTRY_CODE - The seller is ineligible because Square One is not offered in their country. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["MERCHANT_COUNTRY_CODE"] = 4] = "MERCHANT_COUNTRY_CODE";
    /**
     * ELIGIBILITY_QUALIFIER - deprecated
     *
     * @deprecated
     */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["ELIGIBILITY_QUALIFIER"] = 5] = "ELIGIBILITY_QUALIFIER";
    /** EXPERIMENT_ROLLOUT - The seller is ineligible because of experiment rollout. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["EXPERIMENT_ROLLOUT"] = 6] = "EXPERIMENT_ROLLOUT";
    /**
     * OPTIMIZELY_INTEGRATION_ERROR - The seller is ineligible because Optimizely returned statuses
     * other than "SUCCESS" or "USER_NOT_IN_EXPERIMENT", eg. SDK_ERROR, EXPERIMENT_NOT_FOUND etc.
     */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["OPTIMIZELY_INTEGRATION_ERROR"] = 7] = "OPTIMIZELY_INTEGRATION_ERROR";
    /** UNSUPPORTED_ENTRY_POINT - The seller is ineligible because they are using an unsupported entry point. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["UNSUPPORTED_ENTRY_POINT"] = 8] = "UNSUPPORTED_ENTRY_POINT";
    /** SUPERPOS_VERSION_TOO_LOW - The seller is ineligible because their SuperPOS version is too low. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["SUPERPOS_VERSION_TOO_LOW"] = 9] = "SUPERPOS_VERSION_TOO_LOW";
    /**
     * ELIGIBILITY_STATUS_UNDETERMINED - Response including this enum value indicates the eligibility status is not determined and can be changed to Eligible
     * in the future if merchant later qualifies through supported onboarding flows. Clients should not treat the ineligible
     * status as permanent (don't cache this).
     */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["ELIGIBILITY_STATUS_UNDETERMINED"] = 10] = "ELIGIBILITY_STATUS_UNDETERMINED";
    /** OVERRIDE_INELIGIBLE - The seller is ineligible because their eligibility was explicitly overridden to be ineligible */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["OVERRIDE_INELIGIBLE"] = 11] = "OVERRIDE_INELIGIBLE";
    /** LEGACY_CONVERSION_REQUESTED - The seller was initially eligible but requested to revert to the legacy experience. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["LEGACY_CONVERSION_REQUESTED"] = 12] = "LEGACY_CONVERSION_REQUESTED";
    /** LEGACY_VERSION_TOO_LOW - The seller is ineligible because their Legacy POS (VPOS) version is too low. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["LEGACY_VERSION_TOO_LOW"] = 13] = "LEGACY_VERSION_TOO_LOW";
    /** PNP_UNSUPPORTED_ONBOARDING - The seller is ineligible because they were onboarded via the legacy onboarding flow. */
    SquareOneEligibility_IneligibilityReason[SquareOneEligibility_IneligibilityReason["PNP_UNSUPPORTED_ONBOARDING"] = 14] = "PNP_UNSUPPORTED_ONBOARDING";
})(SquareOneEligibility_IneligibilityReason || (SquareOneEligibility_IneligibilityReason = {}));
/** The reason why the seller is not eligible for the Square One GA Migration */
export var GaMigrationEligibility_GaMigrationIneligibilityReason;
(function (GaMigrationEligibility_GaMigrationIneligibilityReason) {
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** ALREADY_MIGRATED - The seller is ineligible because they have already migrated to Square One. */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["ALREADY_MIGRATED"] = 1] = "ALREADY_MIGRATED";
    /** ONGOING_MIGRATION - The seller is ineligible because they are already enrolled in a separate Square One migration. */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["ONGOING_MIGRATION"] = 2] = "ONGOING_MIGRATION";
    /**
     * MULTIMERCHANT - The seller is ineligible because they are part of a multimerchant organization and
     * they can't migrate independently.
     */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["MULTIMERCHANT"] = 3] = "MULTIMERCHANT";
    /** CONTRACTED - The seller is ineligible because they are on a contract */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["CONTRACTED"] = 4] = "CONTRACTED";
    /** INVOICES - The seller is ineligible because they are subscribed to invoices plus via Apple app store or Google Play */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["INVOICES"] = 5] = "INVOICES";
    /** INELIGIBLE_COUNTRY - The seller is ineligible because they are from a country not currently onboarded to Square One */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["INELIGIBLE_COUNTRY"] = 6] = "INELIGIBLE_COUNTRY";
    /** AM_HOLDOUT - The seller is ineligible because of custom holdout reasons defined by AMs */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["AM_HOLDOUT"] = 7] = "AM_HOLDOUT";
    /** PENDING_EVALUATION - A temporary status for sellers who opted out or become ineligible for the enrolled migration_program */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["PENDING_EVALUATION"] = 8] = "PENDING_EVALUATION";
    /** MANUAL_HOLDOUT - Persistent bucket to prevent ad hoc sellers from migrating. Manually handled. */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["MANUAL_HOLDOUT"] = 9] = "MANUAL_HOLDOUT";
    /** SCHEDULED_MIGRATION - Seller has a pending, scheduled migration for some time in the future. */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["SCHEDULED_MIGRATION"] = 10] = "SCHEDULED_MIGRATION";
    /** WEEBLY_SUB - The seller is ineligible because they have an active Weebly subscription that is still billed via weebly's legacy billing platform */
    GaMigrationEligibility_GaMigrationIneligibilityReason[GaMigrationEligibility_GaMigrationIneligibilityReason["WEEBLY_SUB"] = 11] = "WEEBLY_SUB";
})(GaMigrationEligibility_GaMigrationIneligibilityReason || (GaMigrationEligibility_GaMigrationIneligibilityReason = {}));
export var EligibilityQualifier_OnboardingEntryPoint;
(function (EligibilityQualifier_OnboardingEntryPoint) {
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["DO_NOT_USE"] = 0] = "DO_NOT_USE";
    /** SUPERPOS - The seller was onboarded via superPOS */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["SUPERPOS"] = 1] = "SUPERPOS";
    /** GOLDEN_PATH - The seller was onboarded via onboarding web golden path flow */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["GOLDEN_PATH"] = 2] = "GOLDEN_PATH";
    /** LEGACY_POS - The seller was onboarded via legacy POS (VPOS) */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["LEGACY_POS"] = 3] = "LEGACY_POS";
    /** DASHBOARD - The seller was landed in dashboard from ineligible entry- ineligibility entrypoint */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["DASHBOARD"] = 4] = "DASHBOARD";
    /**
     * SQUARE_ONLINE - The seller was onboarded via Square Online (formerly weebly/ecommerce)
     * via online-store web onboarding flow
     */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["SQUARE_ONLINE"] = 5] = "SQUARE_ONLINE";
    /**
     * PNP_ELIGIBLE_ONBOARDING - The enum maps to client eligibility, where the client specifies P&P eligibility for merchant
     * during onboarding
     */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["PNP_ELIGIBLE_ONBOARDING"] = 6] = "PNP_ELIGIBLE_ONBOARDING";
    /**
     * PNP_INELIGIBLE_ONBOARDING - The enum maps to client eligibility, where the client specifies legacy eligibility for merchant
     * during onboarding
     */
    EligibilityQualifier_OnboardingEntryPoint[EligibilityQualifier_OnboardingEntryPoint["PNP_INELIGIBLE_ONBOARDING"] = 7] = "PNP_INELIGIBLE_ONBOARDING";
})(EligibilityQualifier_OnboardingEntryPoint || (EligibilityQualifier_OnboardingEntryPoint = {}));
function createBaseEntity() {
    return { $type: "squareup.sub2.data.Entity", tokenType: undefined, token: undefined };
}
export const Entity = {
    $type: "squareup.sub2.data.Entity",
    encode(message, writer = __m0.Writer.create()) {
        if (message.tokenType !== undefined) {
            writer.uint32(8).int32(message.tokenType);
        }
        if (message.token !== undefined) {
            writer.uint32(18).string(message.token);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEntity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.tokenType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Entity.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEntity();
        message.tokenType = object.tokenType ?? undefined;
        message.token = object.token ?? undefined;
        return message;
    },
};
function createBaseProductOwner() {
    return {
        $type: "squareup.sub2.data.ProductOwner",
        productOwnerEntity: undefined,
        ownerType: undefined,
        countryCode: undefined,
        sellerCode: undefined,
    };
}
export const ProductOwner = {
    $type: "squareup.sub2.data.ProductOwner",
    encode(message, writer = __m0.Writer.create()) {
        if (message.productOwnerEntity !== undefined) {
            Entity.encode(message.productOwnerEntity, writer.uint32(10).fork()).ldelim();
        }
        if (message.ownerType !== undefined) {
            writer.uint32(16).int32(message.ownerType);
        }
        if (message.countryCode !== undefined) {
            writer.uint32(24).int32(message.countryCode);
        }
        if (message.sellerCode !== undefined) {
            writer.uint32(32).int32(message.sellerCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProductOwner();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.productOwnerEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ownerType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.countryCode = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.sellerCode = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ProductOwner.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProductOwner();
        message.productOwnerEntity = (object.productOwnerEntity !== undefined && object.productOwnerEntity !== null)
            ? Entity.fromPartial(object.productOwnerEntity)
            : undefined;
        message.ownerType = object.ownerType ?? undefined;
        message.countryCode = object.countryCode ?? undefined;
        message.sellerCode = object.sellerCode ?? undefined;
        return message;
    },
};
function createBaseProduct() {
    return {
        $type: "squareup.sub2.data.Product",
        productOwner: undefined,
        token: undefined,
        configuration: undefined,
        payType: undefined,
    };
}
export const Product = {
    $type: "squareup.sub2.data.Product",
    encode(message, writer = __m0.Writer.create()) {
        if (message.productOwner !== undefined) {
            ProductOwner.encode(message.productOwner, writer.uint32(10).fork()).ldelim();
        }
        if (message.token !== undefined) {
            writer.uint32(18).string(message.token);
        }
        if (message.configuration !== undefined) {
            ProductConfiguration.encode(message.configuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.payType !== undefined) {
            writer.uint32(32).int32(message.payType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProduct();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.productOwner = ProductOwner.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.configuration = ProductConfiguration.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.payType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Product.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProduct();
        message.productOwner = (object.productOwner !== undefined && object.productOwner !== null)
            ? ProductOwner.fromPartial(object.productOwner)
            : undefined;
        message.token = object.token ?? undefined;
        message.configuration = (object.configuration !== undefined && object.configuration !== null)
            ? ProductConfiguration.fromPartial(object.configuration)
            : undefined;
        message.payType = object.payType ?? undefined;
        return message;
    },
};
function createBaseProductConfiguration() {
    return { $type: "squareup.sub2.data.ProductConfiguration" };
}
export const ProductConfiguration = {
    $type: "squareup.sub2.data.ProductConfiguration",
    encode(_, writer = __m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProductConfiguration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ProductConfiguration.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseProductConfiguration();
        return message;
    },
};
function createBaseDuration() {
    return { $type: "squareup.sub2.data.Duration", unit: undefined, count: undefined };
}
export const Duration = {
    $type: "squareup.sub2.data.Duration",
    encode(message, writer = __m0.Writer.create()) {
        if (message.unit !== undefined) {
            writer.uint32(8).int32(message.unit);
        }
        if (message.count !== undefined) {
            writer.uint32(16).uint32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDuration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unit = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.count = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Duration.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDuration();
        message.unit = object.unit ?? undefined;
        message.count = object.count ?? undefined;
        return message;
    },
};
function createBasePlan() {
    return {
        $type: "squareup.sub2.data.Plan",
        productOwner: undefined,
        productToken: undefined,
        name: undefined,
        availabilityStatus: undefined,
        pricing: undefined,
        renewalCycle: undefined,
        freeTrialDuration: undefined,
        taxClass: undefined,
        feature: [],
        noObligationFreeTrialExpiredDuration: undefined,
        token: undefined,
        requiresExpirationDate: undefined,
        allowMissedPayments: undefined,
        subscriberCanCancel: undefined,
        subscriberCanPause: undefined,
    };
}
export const Plan = {
    $type: "squareup.sub2.data.Plan",
    encode(message, writer = __m0.Writer.create()) {
        if (message.productOwner !== undefined) {
            ProductOwner.encode(message.productOwner, writer.uint32(10).fork()).ldelim();
        }
        if (message.productToken !== undefined) {
            writer.uint32(18).string(message.productToken);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        if (message.availabilityStatus !== undefined) {
            writer.uint32(32).int32(message.availabilityStatus);
        }
        if (message.pricing !== undefined) {
            Pricing.encode(message.pricing, writer.uint32(42).fork()).ldelim();
        }
        if (message.renewalCycle !== undefined) {
            Duration.encode(message.renewalCycle, writer.uint32(50).fork()).ldelim();
        }
        if (message.freeTrialDuration !== undefined) {
            Duration.encode(message.freeTrialDuration, writer.uint32(58).fork()).ldelim();
        }
        if (message.taxClass !== undefined) {
            writer.uint32(66).string(message.taxClass);
        }
        writer.uint32(74).fork();
        for (const v of message.feature) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.noObligationFreeTrialExpiredDuration !== undefined) {
            Duration.encode(message.noObligationFreeTrialExpiredDuration, writer.uint32(82).fork()).ldelim();
        }
        if (message.token !== undefined) {
            writer.uint32(90).string(message.token);
        }
        if (message.requiresExpirationDate !== undefined) {
            writer.uint32(96).bool(message.requiresExpirationDate);
        }
        if (message.allowMissedPayments !== undefined) {
            writer.uint32(104).bool(message.allowMissedPayments);
        }
        if (message.subscriberCanCancel !== undefined) {
            writer.uint32(112).int32(message.subscriberCanCancel);
        }
        if (message.subscriberCanPause !== undefined) {
            writer.uint32(120).int32(message.subscriberCanPause);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.productOwner = ProductOwner.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.productToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.availabilityStatus = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.pricing = Pricing.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.renewalCycle = Duration.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.freeTrialDuration = Duration.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.taxClass = reader.string();
                    continue;
                case 9:
                    if (tag === 72) {
                        message.feature.push(reader.int32());
                        continue;
                    }
                    if (tag === 74) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.feature.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.noObligationFreeTrialExpiredDuration = Duration.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.requiresExpirationDate = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.allowMissedPayments = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.subscriberCanCancel = reader.int32();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.subscriberCanPause = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Plan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlan();
        message.productOwner = (object.productOwner !== undefined && object.productOwner !== null)
            ? ProductOwner.fromPartial(object.productOwner)
            : undefined;
        message.productToken = object.productToken ?? undefined;
        message.name = object.name ?? undefined;
        message.availabilityStatus = object.availabilityStatus ?? undefined;
        message.pricing = (object.pricing !== undefined && object.pricing !== null)
            ? Pricing.fromPartial(object.pricing)
            : undefined;
        message.renewalCycle = (object.renewalCycle !== undefined && object.renewalCycle !== null)
            ? Duration.fromPartial(object.renewalCycle)
            : undefined;
        message.freeTrialDuration = (object.freeTrialDuration !== undefined && object.freeTrialDuration !== null)
            ? Duration.fromPartial(object.freeTrialDuration)
            : undefined;
        message.taxClass = object.taxClass ?? undefined;
        message.feature = object.feature?.map((e) => e) || [];
        message.noObligationFreeTrialExpiredDuration =
            (object.noObligationFreeTrialExpiredDuration !== undefined &&
                object.noObligationFreeTrialExpiredDuration !== null)
                ? Duration.fromPartial(object.noObligationFreeTrialExpiredDuration)
                : undefined;
        message.token = object.token ?? undefined;
        message.requiresExpirationDate = object.requiresExpirationDate ?? undefined;
        message.allowMissedPayments = object.allowMissedPayments ?? undefined;
        message.subscriberCanCancel = object.subscriberCanCancel ?? undefined;
        message.subscriberCanPause = object.subscriberCanPause ?? undefined;
        return message;
    },
};
function createBasePlanComponent() {
    return {
        $type: "squareup.sub2.data.PlanComponent",
        feature: undefined,
        plan: undefined,
        cancelWarning: undefined,
        maintainDescription: undefined,
    };
}
export const PlanComponent = {
    $type: "squareup.sub2.data.PlanComponent",
    encode(message, writer = __m0.Writer.create()) {
        if (message.feature !== undefined) {
            writer.uint32(8).int32(message.feature);
        }
        if (message.plan !== undefined) {
            Plan.encode(message.plan, writer.uint32(18).fork()).ldelim();
        }
        if (message.cancelWarning !== undefined) {
            writer.uint32(26).string(message.cancelWarning);
        }
        if (message.maintainDescription !== undefined) {
            writer.uint32(34).string(message.maintainDescription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanComponent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.feature = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.plan = Plan.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.cancelWarning = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.maintainDescription = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanComponent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanComponent();
        message.feature = object.feature ?? undefined;
        message.plan = (object.plan !== undefined && object.plan !== null) ? Plan.fromPartial(object.plan) : undefined;
        message.cancelWarning = object.cancelWarning ?? undefined;
        message.maintainDescription = object.maintainDescription ?? undefined;
        return message;
    },
};
function createBaseSaasMoney() {
    return { $type: "squareup.sub2.data.SaasMoney", currencyCode: undefined, amount: undefined };
}
export const SaasMoney = {
    $type: "squareup.sub2.data.SaasMoney",
    encode(message, writer = __m0.Writer.create()) {
        const unregisterLong = registerLong();
        try {
            if (message.currencyCode !== undefined) {
                writer.uint32(8).int32(message.currencyCode);
            }
            if (message.amount !== undefined) {
                writer.uint32(16).int64(message.amount);
            }
            return writer;
        }
        finally {
            unregisterLong();
        }
    },
    decode(input, length) {
        const unregisterLong = registerLong();
        try {
            const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
            let end = length === undefined ? reader.len : reader.pos + length;
            const message = createBaseSaasMoney();
            while (reader.pos < end) {
                const tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        if (tag !== 8) {
                            break;
                        }
                        message.currencyCode = reader.int32();
                        continue;
                    case 2:
                        if (tag !== 16) {
                            break;
                        }
                        message.amount = longToNumber(reader.int64());
                        continue;
                }
                if ((tag & 7) === 4 || tag === 0) {
                    break;
                }
                reader.skipType(tag & 7);
            }
            return message;
        }
        finally {
            unregisterLong();
        }
    },
    create(base) {
        return SaasMoney.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSaasMoney();
        message.currencyCode = object.currencyCode ?? undefined;
        message.amount = object.amount ?? undefined;
        return message;
    },
};
function createBaseFixedPricing() {
    return { $type: "squareup.sub2.data.FixedPricing", cost: undefined };
}
export const FixedPricing = {
    $type: "squareup.sub2.data.FixedPricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.cost !== undefined) {
            Money.encode(message.cost, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFixedPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cost = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FixedPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFixedPricing();
        message.cost = (object.cost !== undefined && object.cost !== null) ? Money.fromPartial(object.cost) : undefined;
        return message;
    },
};
function createBaseUsageUnitTypes() {
    return { $type: "squareup.sub2.data.UsageUnitTypes", usageUnitType: [] };
}
export const UsageUnitTypes = {
    $type: "squareup.sub2.data.UsageUnitTypes",
    encode(message, writer = __m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.usageUnitType) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsageUnitTypes();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.usageUnitType.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.usageUnitType.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return UsageUnitTypes.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUsageUnitTypes();
        message.usageUnitType = object.usageUnitType?.map((e) => e) || [];
        return message;
    },
};
function createBaseTieredPricing() {
    return {
        $type: "squareup.sub2.data.TieredPricing",
        unitType: undefined,
        pricingTier: [],
        currentTier: undefined,
        calculation: undefined,
    };
}
export const TieredPricing = {
    $type: "squareup.sub2.data.TieredPricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.unitType !== undefined) {
            writer.uint32(8).int32(message.unitType);
        }
        for (const v of message.pricingTier) {
            TieredPricing_Tier.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.currentTier !== undefined) {
            TieredPricing_Tier.encode(message.currentTier, writer.uint32(26).fork()).ldelim();
        }
        if (message.calculation !== undefined) {
            writer.uint32(32).int32(message.calculation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTieredPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.pricingTier.push(TieredPricing_Tier.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.currentTier = TieredPricing_Tier.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.calculation = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return TieredPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTieredPricing();
        message.unitType = object.unitType ?? undefined;
        message.pricingTier = object.pricingTier?.map((e) => TieredPricing_Tier.fromPartial(e)) || [];
        message.currentTier = (object.currentTier !== undefined && object.currentTier !== null)
            ? TieredPricing_Tier.fromPartial(object.currentTier)
            : undefined;
        message.calculation = object.calculation ?? undefined;
        return message;
    },
};
function createBaseTieredPricing_Tier() {
    return {
        $type: "squareup.sub2.data.TieredPricing.Tier",
        name: undefined,
        minUsageCount: undefined,
        maxUsageCount: undefined,
        cost: undefined,
        baseCost: undefined,
    };
}
export const TieredPricing_Tier = {
    $type: "squareup.sub2.data.TieredPricing.Tier",
    encode(message, writer = __m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.minUsageCount !== undefined) {
            writer.uint32(24).uint32(message.minUsageCount);
        }
        if (message.maxUsageCount !== undefined) {
            writer.uint32(32).uint32(message.maxUsageCount);
        }
        if (message.cost !== undefined) {
            Money.encode(message.cost, writer.uint32(42).fork()).ldelim();
        }
        if (message.baseCost !== undefined) {
            Money.encode(message.baseCost, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTieredPricing_Tier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.minUsageCount = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.maxUsageCount = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.cost = Money.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.baseCost = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return TieredPricing_Tier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTieredPricing_Tier();
        message.name = object.name ?? undefined;
        message.minUsageCount = object.minUsageCount ?? undefined;
        message.maxUsageCount = object.maxUsageCount ?? undefined;
        message.cost = (object.cost !== undefined && object.cost !== null) ? Money.fromPartial(object.cost) : undefined;
        message.baseCost = (object.baseCost !== undefined && object.baseCost !== null)
            ? Money.fromPartial(object.baseCost)
            : undefined;
        return message;
    },
};
function createBaseBucketPricing() {
    return {
        $type: "squareup.sub2.data.BucketPricing",
        cost: undefined,
        unitType: undefined,
        bucketSize: undefined,
        minUnits: undefined,
        baseCost: undefined,
    };
}
export const BucketPricing = {
    $type: "squareup.sub2.data.BucketPricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.cost !== undefined) {
            Money.encode(message.cost, writer.uint32(10).fork()).ldelim();
        }
        if (message.unitType !== undefined) {
            writer.uint32(16).int32(message.unitType);
        }
        if (message.bucketSize !== undefined) {
            writer.uint32(24).uint32(message.bucketSize);
        }
        if (message.minUnits !== undefined) {
            writer.uint32(32).uint32(message.minUnits);
        }
        if (message.baseCost !== undefined) {
            Money.encode(message.baseCost, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBucketPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cost = Money.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.bucketSize = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.minUnits = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.baseCost = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BucketPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBucketPricing();
        message.cost = (object.cost !== undefined && object.cost !== null) ? Money.fromPartial(object.cost) : undefined;
        message.unitType = object.unitType ?? undefined;
        message.bucketSize = object.bucketSize ?? undefined;
        message.minUnits = object.minUnits ?? undefined;
        message.baseCost = (object.baseCost !== undefined && object.baseCost !== null)
            ? Money.fromPartial(object.baseCost)
            : undefined;
        return message;
    },
};
function createBaseUsageBucket() {
    return {
        $type: "squareup.sub2.data.UsageBucket",
        cost: undefined,
        unitType: undefined,
        size: undefined,
        minUnits: undefined,
        label: undefined,
        freeUnitCount: undefined,
        fractionalCost: undefined,
    };
}
export const UsageBucket = {
    $type: "squareup.sub2.data.UsageBucket",
    encode(message, writer = __m0.Writer.create()) {
        if (message.cost !== undefined) {
            Money.encode(message.cost, writer.uint32(10).fork()).ldelim();
        }
        if (message.unitType !== undefined) {
            writer.uint32(16).int32(message.unitType);
        }
        if (message.size !== undefined) {
            writer.uint32(24).uint32(message.size);
        }
        if (message.minUnits !== undefined) {
            writer.uint32(32).uint32(message.minUnits);
        }
        if (message.label !== undefined) {
            writer.uint32(42).string(message.label);
        }
        if (message.freeUnitCount !== undefined) {
            writer.uint32(48).uint32(message.freeUnitCount);
        }
        if (message.fractionalCost !== undefined) {
            SaasMoney.encode(message.fractionalCost, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsageBucket();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cost = Money.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.size = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.minUnits = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.freeUnitCount = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.fractionalCost = SaasMoney.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return UsageBucket.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUsageBucket();
        message.cost = (object.cost !== undefined && object.cost !== null) ? Money.fromPartial(object.cost) : undefined;
        message.unitType = object.unitType ?? undefined;
        message.size = object.size ?? undefined;
        message.minUnits = object.minUnits ?? undefined;
        message.label = object.label ?? undefined;
        message.freeUnitCount = object.freeUnitCount ?? undefined;
        message.fractionalCost = (object.fractionalCost !== undefined && object.fractionalCost !== null)
            ? SaasMoney.fromPartial(object.fractionalCost)
            : undefined;
        return message;
    },
};
function createBaseMultiBucketPricing() {
    return { $type: "squareup.sub2.data.MultiBucketPricing", buckets: [], baseCost: undefined };
}
export const MultiBucketPricing = {
    $type: "squareup.sub2.data.MultiBucketPricing",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.buckets) {
            UsageBucket.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.baseCost !== undefined) {
            Money.encode(message.baseCost, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMultiBucketPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.buckets.push(UsageBucket.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.baseCost = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MultiBucketPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMultiBucketPricing();
        message.buckets = object.buckets?.map((e) => UsageBucket.fromPartial(e)) || [];
        message.baseCost = (object.baseCost !== undefined && object.baseCost !== null)
            ? Money.fromPartial(object.baseCost)
            : undefined;
        return message;
    },
};
function createBaseRetailPricing() {
    return {
        $type: "squareup.sub2.data.RetailPricing",
        retailDeviceCost: undefined,
        excessEmployeeCost: undefined,
        excessCustomerBucketCost: undefined,
    };
}
export const RetailPricing = {
    $type: "squareup.sub2.data.RetailPricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.retailDeviceCost !== undefined) {
            Money.encode(message.retailDeviceCost, writer.uint32(10).fork()).ldelim();
        }
        if (message.excessEmployeeCost !== undefined) {
            Money.encode(message.excessEmployeeCost, writer.uint32(18).fork()).ldelim();
        }
        if (message.excessCustomerBucketCost !== undefined) {
            Money.encode(message.excessCustomerBucketCost, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRetailPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.retailDeviceCost = Money.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.excessEmployeeCost = Money.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.excessCustomerBucketCost = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return RetailPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRetailPricing();
        message.retailDeviceCost = (object.retailDeviceCost !== undefined && object.retailDeviceCost !== null)
            ? Money.fromPartial(object.retailDeviceCost)
            : undefined;
        message.excessEmployeeCost = (object.excessEmployeeCost !== undefined && object.excessEmployeeCost !== null)
            ? Money.fromPartial(object.excessEmployeeCost)
            : undefined;
        message.excessCustomerBucketCost =
            (object.excessCustomerBucketCost !== undefined && object.excessCustomerBucketCost !== null)
                ? Money.fromPartial(object.excessCustomerBucketCost)
                : undefined;
        return message;
    },
};
function createBasePricing() {
    return {
        $type: "squareup.sub2.data.Pricing",
        fixedPricing: undefined,
        bucketPricing: undefined,
        retailPricing: undefined,
        tieredPricing: undefined,
        multiBucketPricing: undefined,
        label: undefined,
        startAt: undefined,
        expireAt: undefined,
        customPricing: undefined,
    };
}
export const Pricing = {
    $type: "squareup.sub2.data.Pricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.fixedPricing !== undefined) {
            FixedPricing.encode(message.fixedPricing, writer.uint32(10).fork()).ldelim();
        }
        if (message.bucketPricing !== undefined) {
            BucketPricing.encode(message.bucketPricing, writer.uint32(18).fork()).ldelim();
        }
        if (message.retailPricing !== undefined) {
            RetailPricing.encode(message.retailPricing, writer.uint32(26).fork()).ldelim();
        }
        if (message.tieredPricing !== undefined) {
            TieredPricing.encode(message.tieredPricing, writer.uint32(34).fork()).ldelim();
        }
        if (message.multiBucketPricing !== undefined) {
            MultiBucketPricing.encode(message.multiBucketPricing, writer.uint32(50).fork()).ldelim();
        }
        if (message.label !== undefined) {
            writer.uint32(42).string(message.label);
        }
        if (message.startAt !== undefined) {
            DateTime.encode(message.startAt, writer.uint32(58).fork()).ldelim();
        }
        if (message.expireAt !== undefined) {
            DateTime.encode(message.expireAt, writer.uint32(66).fork()).ldelim();
        }
        if (message.customPricing !== undefined) {
            writer.uint32(72).bool(message.customPricing);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.fixedPricing = FixedPricing.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.bucketPricing = BucketPricing.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.retailPricing = RetailPricing.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.tieredPricing = TieredPricing.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.multiBucketPricing = MultiBucketPricing.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.startAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.expireAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.customPricing = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Pricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePricing();
        message.fixedPricing = (object.fixedPricing !== undefined && object.fixedPricing !== null)
            ? FixedPricing.fromPartial(object.fixedPricing)
            : undefined;
        message.bucketPricing = (object.bucketPricing !== undefined && object.bucketPricing !== null)
            ? BucketPricing.fromPartial(object.bucketPricing)
            : undefined;
        message.retailPricing = (object.retailPricing !== undefined && object.retailPricing !== null)
            ? RetailPricing.fromPartial(object.retailPricing)
            : undefined;
        message.tieredPricing = (object.tieredPricing !== undefined && object.tieredPricing !== null)
            ? TieredPricing.fromPartial(object.tieredPricing)
            : undefined;
        message.multiBucketPricing = (object.multiBucketPricing !== undefined && object.multiBucketPricing !== null)
            ? MultiBucketPricing.fromPartial(object.multiBucketPricing)
            : undefined;
        message.label = object.label ?? undefined;
        message.startAt = (object.startAt !== undefined && object.startAt !== null)
            ? DateTime.fromPartial(object.startAt)
            : undefined;
        message.expireAt = (object.expireAt !== undefined && object.expireAt !== null)
            ? DateTime.fromPartial(object.expireAt)
            : undefined;
        message.customPricing = object.customPricing ?? undefined;
        return message;
    },
};
function createBaseSubscriber() {
    return { $type: "squareup.sub2.data.Subscriber", subscriberEntity: undefined, tzName: undefined };
}
export const Subscriber = {
    $type: "squareup.sub2.data.Subscriber",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscriberEntity !== undefined) {
            Entity.encode(message.subscriberEntity, writer.uint32(10).fork()).ldelim();
        }
        if (message.tzName !== undefined) {
            writer.uint32(18).string(message.tzName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriber();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscriberEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tzName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Subscriber.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriber();
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.tzName = object.tzName ?? undefined;
        return message;
    },
};
function createBaseSingleUnitUsage() {
    return { $type: "squareup.sub2.data.SingleUnitUsage", unitType: undefined, count: undefined };
}
export const SingleUnitUsage = {
    $type: "squareup.sub2.data.SingleUnitUsage",
    encode(message, writer = __m0.Writer.create()) {
        if (message.unitType !== undefined) {
            writer.uint32(8).int32(message.unitType);
        }
        if (message.count !== undefined) {
            writer.uint32(16).uint32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSingleUnitUsage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.count = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SingleUnitUsage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSingleUnitUsage();
        message.unitType = object.unitType ?? undefined;
        message.count = object.count ?? undefined;
        return message;
    },
};
function createBasePlanChange() {
    return {
        $type: "squareup.sub2.data.PlanChange",
        effectiveAt: undefined,
        planToken: undefined,
        planName: undefined,
        previousSubscriptionStatus: undefined,
        previousPlanToken: undefined,
        previousPlanBillingCycle: undefined,
    };
}
export const PlanChange = {
    $type: "squareup.sub2.data.PlanChange",
    encode(message, writer = __m0.Writer.create()) {
        if (message.effectiveAt !== undefined) {
            DateTime.encode(message.effectiveAt, writer.uint32(10).fork()).ldelim();
        }
        if (message.planToken !== undefined) {
            writer.uint32(18).string(message.planToken);
        }
        if (message.planName !== undefined) {
            writer.uint32(26).string(message.planName);
        }
        if (message.previousSubscriptionStatus !== undefined) {
            writer.uint32(32).int32(message.previousSubscriptionStatus);
        }
        if (message.previousPlanToken !== undefined) {
            writer.uint32(42).string(message.previousPlanToken);
        }
        if (message.previousPlanBillingCycle !== undefined) {
            writer.uint32(50).string(message.previousPlanBillingCycle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanChange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.effectiveAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.planName = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.previousSubscriptionStatus = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.previousPlanToken = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.previousPlanBillingCycle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanChange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanChange();
        message.effectiveAt = (object.effectiveAt !== undefined && object.effectiveAt !== null)
            ? DateTime.fromPartial(object.effectiveAt)
            : undefined;
        message.planToken = object.planToken ?? undefined;
        message.planName = object.planName ?? undefined;
        message.previousSubscriptionStatus = object.previousSubscriptionStatus ?? undefined;
        message.previousPlanToken = object.previousPlanToken ?? undefined;
        message.previousPlanBillingCycle = object.previousPlanBillingCycle ?? undefined;
        return message;
    },
};
function createBaseUsage() {
    return { $type: "squareup.sub2.data.Usage", unitUsages: [] };
}
export const Usage = {
    $type: "squareup.sub2.data.Usage",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.unitUsages) {
            SingleUnitUsage.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.unitUsages.push(SingleUnitUsage.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Usage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUsage();
        message.unitUsages = object.unitUsages?.map((e) => SingleUnitUsage.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSubscription() {
    return {
        $type: "squareup.sub2.data.Subscription",
        token: undefined,
        subscriberEntity: undefined,
        planToken: undefined,
        productOwnerEntity: undefined,
        status: undefined,
        billingStatus: undefined,
        startAt: undefined,
        endAt: undefined,
        freeTrialEndDate: undefined,
        renewalAt: undefined,
        planName: undefined,
        freeTrialEndAt: undefined,
        nextFeeAmount: undefined,
        currentUsage: undefined,
        renewalCycle: undefined,
        pricing: undefined,
        nextFeeDate: undefined,
        currentCost: undefined,
        features: [],
        paused: undefined,
        pauseAt: undefined,
        resumeAt: undefined,
        pendingDowngrade: undefined,
        lastPlanChange: undefined,
        free: undefined,
        planGroupToken: undefined,
        planBillingCycle: undefined,
        delinquentAt: undefined,
        canPause: undefined,
        bundleToken: undefined,
        managedBy: undefined,
        pendingPricing: undefined,
        version: undefined,
        canCancel: undefined,
        expireAt: undefined,
    };
}
export const Subscription = {
    $type: "squareup.sub2.data.Subscription",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        if (message.subscriberEntity !== undefined) {
            Entity.encode(message.subscriberEntity, writer.uint32(18).fork()).ldelim();
        }
        if (message.planToken !== undefined) {
            writer.uint32(26).string(message.planToken);
        }
        if (message.productOwnerEntity !== undefined) {
            Entity.encode(message.productOwnerEntity, writer.uint32(34).fork()).ldelim();
        }
        if (message.status !== undefined) {
            writer.uint32(40).int32(message.status);
        }
        if (message.billingStatus !== undefined) {
            writer.uint32(48).int32(message.billingStatus);
        }
        if (message.startAt !== undefined) {
            DateTime.encode(message.startAt, writer.uint32(58).fork()).ldelim();
        }
        if (message.endAt !== undefined) {
            DateTime.encode(message.endAt, writer.uint32(66).fork()).ldelim();
        }
        if (message.freeTrialEndDate !== undefined) {
            YearMonthDay.encode(message.freeTrialEndDate, writer.uint32(74).fork()).ldelim();
        }
        if (message.renewalAt !== undefined) {
            DateTime.encode(message.renewalAt, writer.uint32(82).fork()).ldelim();
        }
        if (message.planName !== undefined) {
            writer.uint32(90).string(message.planName);
        }
        if (message.freeTrialEndAt !== undefined) {
            DateTime.encode(message.freeTrialEndAt, writer.uint32(98).fork()).ldelim();
        }
        if (message.nextFeeAmount !== undefined) {
            Money.encode(message.nextFeeAmount, writer.uint32(106).fork()).ldelim();
        }
        if (message.currentUsage !== undefined) {
            Usage.encode(message.currentUsage, writer.uint32(114).fork()).ldelim();
        }
        if (message.renewalCycle !== undefined) {
            Duration.encode(message.renewalCycle, writer.uint32(122).fork()).ldelim();
        }
        if (message.pricing !== undefined) {
            Pricing.encode(message.pricing, writer.uint32(130).fork()).ldelim();
        }
        if (message.nextFeeDate !== undefined) {
            DateTime.encode(message.nextFeeDate, writer.uint32(138).fork()).ldelim();
        }
        if (message.currentCost !== undefined) {
            Money.encode(message.currentCost, writer.uint32(146).fork()).ldelim();
        }
        writer.uint32(154).fork();
        for (const v of message.features) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.paused !== undefined) {
            writer.uint32(160).bool(message.paused);
        }
        if (message.pauseAt !== undefined) {
            DateTime.encode(message.pauseAt, writer.uint32(178).fork()).ldelim();
        }
        if (message.resumeAt !== undefined) {
            DateTime.encode(message.resumeAt, writer.uint32(170).fork()).ldelim();
        }
        if (message.pendingDowngrade !== undefined) {
            PlanChange.encode(message.pendingDowngrade, writer.uint32(186).fork()).ldelim();
        }
        if (message.lastPlanChange !== undefined) {
            PlanChange.encode(message.lastPlanChange, writer.uint32(194).fork()).ldelim();
        }
        if (message.free !== undefined) {
            writer.uint32(200).bool(message.free);
        }
        if (message.planGroupToken !== undefined) {
            writer.uint32(210).string(message.planGroupToken);
        }
        if (message.planBillingCycle !== undefined) {
            writer.uint32(224).int32(message.planBillingCycle);
        }
        if (message.delinquentAt !== undefined) {
            DateTime.encode(message.delinquentAt, writer.uint32(234).fork()).ldelim();
        }
        if (message.canPause !== undefined) {
            writer.uint32(240).bool(message.canPause);
        }
        if (message.bundleToken !== undefined) {
            writer.uint32(250).string(message.bundleToken);
        }
        if (message.managedBy !== undefined) {
            writer.uint32(256).int32(message.managedBy);
        }
        if (message.pendingPricing !== undefined) {
            Pricing.encode(message.pendingPricing, writer.uint32(266).fork()).ldelim();
        }
        if (message.version !== undefined) {
            writer.uint32(272).int32(message.version);
        }
        if (message.canCancel !== undefined) {
            writer.uint32(280).bool(message.canCancel);
        }
        if (message.expireAt !== undefined) {
            DateTime.encode(message.expireAt, writer.uint32(290).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriberEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.productOwnerEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.billingStatus = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.startAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.endAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.freeTrialEndDate = YearMonthDay.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.renewalAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.planName = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.freeTrialEndAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.nextFeeAmount = Money.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.currentUsage = Usage.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.renewalCycle = Duration.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.pricing = Pricing.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.nextFeeDate = DateTime.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.currentCost = Money.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag === 152) {
                        message.features.push(reader.int32());
                        continue;
                    }
                    if (tag === 154) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.features.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.paused = reader.bool();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.pauseAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.resumeAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.pendingDowngrade = PlanChange.decode(reader, reader.uint32());
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.lastPlanChange = PlanChange.decode(reader, reader.uint32());
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.free = reader.bool();
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.planGroupToken = reader.string();
                    continue;
                case 28:
                    if (tag !== 224) {
                        break;
                    }
                    message.planBillingCycle = reader.int32();
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.delinquentAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 30:
                    if (tag !== 240) {
                        break;
                    }
                    message.canPause = reader.bool();
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.bundleToken = reader.string();
                    continue;
                case 32:
                    if (tag !== 256) {
                        break;
                    }
                    message.managedBy = reader.int32();
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.pendingPricing = Pricing.decode(reader, reader.uint32());
                    continue;
                case 34:
                    if (tag !== 272) {
                        break;
                    }
                    message.version = reader.int32();
                    continue;
                case 35:
                    if (tag !== 280) {
                        break;
                    }
                    message.canCancel = reader.bool();
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.expireAt = DateTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Subscription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscription();
        message.token = object.token ?? undefined;
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.planToken = object.planToken ?? undefined;
        message.productOwnerEntity = (object.productOwnerEntity !== undefined && object.productOwnerEntity !== null)
            ? Entity.fromPartial(object.productOwnerEntity)
            : undefined;
        message.status = object.status ?? undefined;
        message.billingStatus = object.billingStatus ?? undefined;
        message.startAt = (object.startAt !== undefined && object.startAt !== null)
            ? DateTime.fromPartial(object.startAt)
            : undefined;
        message.endAt = (object.endAt !== undefined && object.endAt !== null)
            ? DateTime.fromPartial(object.endAt)
            : undefined;
        message.freeTrialEndDate = (object.freeTrialEndDate !== undefined && object.freeTrialEndDate !== null)
            ? YearMonthDay.fromPartial(object.freeTrialEndDate)
            : undefined;
        message.renewalAt = (object.renewalAt !== undefined && object.renewalAt !== null)
            ? DateTime.fromPartial(object.renewalAt)
            : undefined;
        message.planName = object.planName ?? undefined;
        message.freeTrialEndAt = (object.freeTrialEndAt !== undefined && object.freeTrialEndAt !== null)
            ? DateTime.fromPartial(object.freeTrialEndAt)
            : undefined;
        message.nextFeeAmount = (object.nextFeeAmount !== undefined && object.nextFeeAmount !== null)
            ? Money.fromPartial(object.nextFeeAmount)
            : undefined;
        message.currentUsage = (object.currentUsage !== undefined && object.currentUsage !== null)
            ? Usage.fromPartial(object.currentUsage)
            : undefined;
        message.renewalCycle = (object.renewalCycle !== undefined && object.renewalCycle !== null)
            ? Duration.fromPartial(object.renewalCycle)
            : undefined;
        message.pricing = (object.pricing !== undefined && object.pricing !== null)
            ? Pricing.fromPartial(object.pricing)
            : undefined;
        message.nextFeeDate = (object.nextFeeDate !== undefined && object.nextFeeDate !== null)
            ? DateTime.fromPartial(object.nextFeeDate)
            : undefined;
        message.currentCost = (object.currentCost !== undefined && object.currentCost !== null)
            ? Money.fromPartial(object.currentCost)
            : undefined;
        message.features = object.features?.map((e) => e) || [];
        message.paused = object.paused ?? undefined;
        message.pauseAt = (object.pauseAt !== undefined && object.pauseAt !== null)
            ? DateTime.fromPartial(object.pauseAt)
            : undefined;
        message.resumeAt = (object.resumeAt !== undefined && object.resumeAt !== null)
            ? DateTime.fromPartial(object.resumeAt)
            : undefined;
        message.pendingDowngrade = (object.pendingDowngrade !== undefined && object.pendingDowngrade !== null)
            ? PlanChange.fromPartial(object.pendingDowngrade)
            : undefined;
        message.lastPlanChange = (object.lastPlanChange !== undefined && object.lastPlanChange !== null)
            ? PlanChange.fromPartial(object.lastPlanChange)
            : undefined;
        message.free = object.free ?? undefined;
        message.planGroupToken = object.planGroupToken ?? undefined;
        message.planBillingCycle = object.planBillingCycle ?? undefined;
        message.delinquentAt = (object.delinquentAt !== undefined && object.delinquentAt !== null)
            ? DateTime.fromPartial(object.delinquentAt)
            : undefined;
        message.canPause = object.canPause ?? undefined;
        message.bundleToken = object.bundleToken ?? undefined;
        message.managedBy = object.managedBy ?? undefined;
        message.pendingPricing = (object.pendingPricing !== undefined && object.pendingPricing !== null)
            ? Pricing.fromPartial(object.pendingPricing)
            : undefined;
        message.version = object.version ?? undefined;
        message.canCancel = object.canCancel ?? undefined;
        message.expireAt = (object.expireAt !== undefined && object.expireAt !== null)
            ? DateTime.fromPartial(object.expireAt)
            : undefined;
        return message;
    },
};
function createBaseSubscriptionDetail() {
    return {
        $type: "squareup.sub2.data.SubscriptionDetail",
        subscription: undefined,
        subscriber: undefined,
        plan: undefined,
        recurringCharge: undefined,
        currentUsage: undefined,
    };
}
export const SubscriptionDetail = {
    $type: "squareup.sub2.data.SubscriptionDetail",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscription !== undefined) {
            Subscription.encode(message.subscription, writer.uint32(10).fork()).ldelim();
        }
        if (message.subscriber !== undefined) {
            Subscriber.encode(message.subscriber, writer.uint32(18).fork()).ldelim();
        }
        if (message.plan !== undefined) {
            Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        }
        if (message.recurringCharge !== undefined) {
            Cart.encode(message.recurringCharge, writer.uint32(34).fork()).ldelim();
        }
        if (message.currentUsage !== undefined) {
            Usage.encode(message.currentUsage, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionDetail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscription = Subscription.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriber = Subscriber.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.plan = Plan.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.recurringCharge = Cart.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.currentUsage = Usage.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionDetail.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionDetail();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? Subscription.fromPartial(object.subscription)
            : undefined;
        message.subscriber = (object.subscriber !== undefined && object.subscriber !== null)
            ? Subscriber.fromPartial(object.subscriber)
            : undefined;
        message.plan = (object.plan !== undefined && object.plan !== null) ? Plan.fromPartial(object.plan) : undefined;
        message.recurringCharge = (object.recurringCharge !== undefined && object.recurringCharge !== null)
            ? Cart.fromPartial(object.recurringCharge)
            : undefined;
        message.currentUsage = (object.currentUsage !== undefined && object.currentUsage !== null)
            ? Usage.fromPartial(object.currentUsage)
            : undefined;
        return message;
    },
};
function createBaseCharge() {
    return {
        $type: "squareup.sub2.data.Charge",
        token: undefined,
        subscriptionToken: undefined,
        status: undefined,
        chargeTime: undefined,
        cart: undefined,
    };
}
export const Charge = {
    $type: "squareup.sub2.data.Charge",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        if (message.subscriptionToken !== undefined) {
            writer.uint32(18).string(message.subscriptionToken);
        }
        if (message.status !== undefined) {
            writer.uint32(24).int32(message.status);
        }
        if (message.chargeTime !== undefined) {
            DateTime.encode(message.chargeTime, writer.uint32(34).fork()).ldelim();
        }
        if (message.cart !== undefined) {
            Cart.encode(message.cart, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCharge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriptionToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.chargeTime = DateTime.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.cart = Cart.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Charge.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCharge();
        message.token = object.token ?? undefined;
        message.subscriptionToken = object.subscriptionToken ?? undefined;
        message.status = object.status ?? undefined;
        message.chargeTime = (object.chargeTime !== undefined && object.chargeTime !== null)
            ? DateTime.fromPartial(object.chargeTime)
            : undefined;
        message.cart = (object.cart !== undefined && object.cart !== null) ? Cart.fromPartial(object.cart) : undefined;
        return message;
    },
};
function createBaseSubscribedFeature() {
    return {
        $type: "squareup.sub2.data.SubscribedFeature",
        feature: undefined,
        subscriptionStatus: undefined,
        subscriptionToken: undefined,
        enabled: undefined,
    };
}
export const SubscribedFeature = {
    $type: "squareup.sub2.data.SubscribedFeature",
    encode(message, writer = __m0.Writer.create()) {
        if (message.feature !== undefined) {
            writer.uint32(8).int32(message.feature);
        }
        if (message.subscriptionStatus !== undefined) {
            writer.uint32(16).int32(message.subscriptionStatus);
        }
        if (message.subscriptionToken !== undefined) {
            writer.uint32(26).string(message.subscriptionToken);
        }
        if (message.enabled !== undefined) {
            writer.uint32(32).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscribedFeature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.feature = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.subscriptionStatus = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.subscriptionToken = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscribedFeature.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribedFeature();
        message.feature = object.feature ?? undefined;
        message.subscriptionStatus = object.subscriptionStatus ?? undefined;
        message.subscriptionToken = object.subscriptionToken ?? undefined;
        message.enabled = object.enabled ?? undefined;
        return message;
    },
};
function createBaseDisplayedFeature() {
    return { $type: "squareup.sub2.data.DisplayedFeature", featureName: undefined, featureDescription: undefined };
}
export const DisplayedFeature = {
    $type: "squareup.sub2.data.DisplayedFeature",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureName !== undefined) {
            writer.uint32(8).int32(message.featureName);
        }
        if (message.featureDescription !== undefined) {
            writer.uint32(18).string(message.featureDescription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDisplayedFeature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureName = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.featureDescription = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DisplayedFeature.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisplayedFeature();
        message.featureName = object.featureName ?? undefined;
        message.featureDescription = object.featureDescription ?? undefined;
        return message;
    },
};
function createBaseSubscribedFeatureFeedEntry() {
    return {
        $type: "squareup.sub2.data.SubscribedFeatureFeedEntry",
        feature: undefined,
        productOwnerEntity: undefined,
        status: undefined,
        subscriptionToken: undefined,
        subscriberEntity: undefined,
        subscriptionStatus: undefined,
        createdAt: undefined,
        enabled: undefined,
        feedSyncId: undefined,
    };
}
export const SubscribedFeatureFeedEntry = {
    $type: "squareup.sub2.data.SubscribedFeatureFeedEntry",
    encode(message, writer = __m0.Writer.create()) {
        const unregisterLong = registerLong();
        try {
            if (message.feature !== undefined) {
                writer.uint32(8).int32(message.feature);
            }
            if (message.productOwnerEntity !== undefined) {
                Entity.encode(message.productOwnerEntity, writer.uint32(18).fork()).ldelim();
            }
            if (message.status !== undefined) {
                writer.uint32(48).int32(message.status);
            }
            if (message.subscriptionToken !== undefined) {
                writer.uint32(34).string(message.subscriptionToken);
            }
            if (message.subscriberEntity !== undefined) {
                Entity.encode(message.subscriberEntity, writer.uint32(42).fork()).ldelim();
            }
            if (message.subscriptionStatus !== undefined) {
                writer.uint32(24).int32(message.subscriptionStatus);
            }
            if (message.createdAt !== undefined) {
                writer.uint32(56).int64(message.createdAt);
            }
            if (message.enabled !== undefined) {
                writer.uint32(64).bool(message.enabled);
            }
            if (message.feedSyncId !== undefined) {
                writer.uint32(72).int64(message.feedSyncId);
            }
            return writer;
        }
        finally {
            unregisterLong();
        }
    },
    decode(input, length) {
        const unregisterLong = registerLong();
        try {
            const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
            let end = length === undefined ? reader.len : reader.pos + length;
            const message = createBaseSubscribedFeatureFeedEntry();
            while (reader.pos < end) {
                const tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        if (tag !== 8) {
                            break;
                        }
                        message.feature = reader.int32();
                        continue;
                    case 2:
                        if (tag !== 18) {
                            break;
                        }
                        message.productOwnerEntity = Entity.decode(reader, reader.uint32());
                        continue;
                    case 6:
                        if (tag !== 48) {
                            break;
                        }
                        message.status = reader.int32();
                        continue;
                    case 4:
                        if (tag !== 34) {
                            break;
                        }
                        message.subscriptionToken = reader.string();
                        continue;
                    case 5:
                        if (tag !== 42) {
                            break;
                        }
                        message.subscriberEntity = Entity.decode(reader, reader.uint32());
                        continue;
                    case 3:
                        if (tag !== 24) {
                            break;
                        }
                        message.subscriptionStatus = reader.int32();
                        continue;
                    case 7:
                        if (tag !== 56) {
                            break;
                        }
                        message.createdAt = longToNumber(reader.int64());
                        continue;
                    case 8:
                        if (tag !== 64) {
                            break;
                        }
                        message.enabled = reader.bool();
                        continue;
                    case 9:
                        if (tag !== 72) {
                            break;
                        }
                        message.feedSyncId = longToNumber(reader.int64());
                        continue;
                }
                if ((tag & 7) === 4 || tag === 0) {
                    break;
                }
                reader.skipType(tag & 7);
            }
            return message;
        }
        finally {
            unregisterLong();
        }
    },
    create(base) {
        return SubscribedFeatureFeedEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribedFeatureFeedEntry();
        message.feature = object.feature ?? undefined;
        message.productOwnerEntity = (object.productOwnerEntity !== undefined && object.productOwnerEntity !== null)
            ? Entity.fromPartial(object.productOwnerEntity)
            : undefined;
        message.status = object.status ?? undefined;
        message.subscriptionToken = object.subscriptionToken ?? undefined;
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.subscriptionStatus = object.subscriptionStatus ?? undefined;
        message.createdAt = object.createdAt ?? undefined;
        message.enabled = object.enabled ?? undefined;
        message.feedSyncId = object.feedSyncId ?? undefined;
        return message;
    },
};
function createBaseSubscriberUsageFeedEntry() {
    return {
        $type: "squareup.sub2.data.SubscriberUsageFeedEntry",
        subscriberEntity: undefined,
        productOwnerEntity: undefined,
        unitUsage: undefined,
        startAt: undefined,
        endAt: undefined,
        source: undefined,
    };
}
export const SubscriberUsageFeedEntry = {
    $type: "squareup.sub2.data.SubscriberUsageFeedEntry",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscriberEntity !== undefined) {
            Entity.encode(message.subscriberEntity, writer.uint32(10).fork()).ldelim();
        }
        if (message.productOwnerEntity !== undefined) {
            Entity.encode(message.productOwnerEntity, writer.uint32(18).fork()).ldelim();
        }
        if (message.unitUsage !== undefined) {
            SingleUnitUsage.encode(message.unitUsage, writer.uint32(26).fork()).ldelim();
        }
        if (message.startAt !== undefined) {
            DateTime.encode(message.startAt, writer.uint32(34).fork()).ldelim();
        }
        if (message.endAt !== undefined) {
            DateTime.encode(message.endAt, writer.uint32(42).fork()).ldelim();
        }
        if (message.source !== undefined) {
            writer.uint32(50).string(message.source);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriberUsageFeedEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscriberEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.productOwnerEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.unitUsage = SingleUnitUsage.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.startAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.endAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.source = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriberUsageFeedEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriberUsageFeedEntry();
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.productOwnerEntity = (object.productOwnerEntity !== undefined && object.productOwnerEntity !== null)
            ? Entity.fromPartial(object.productOwnerEntity)
            : undefined;
        message.unitUsage = (object.unitUsage !== undefined && object.unitUsage !== null)
            ? SingleUnitUsage.fromPartial(object.unitUsage)
            : undefined;
        message.startAt = (object.startAt !== undefined && object.startAt !== null)
            ? DateTime.fromPartial(object.startAt)
            : undefined;
        message.endAt = (object.endAt !== undefined && object.endAt !== null)
            ? DateTime.fromPartial(object.endAt)
            : undefined;
        message.source = object.source ?? undefined;
        return message;
    },
};
function createBaseSubscriptionUsageTypeFeedEntry() {
    return {
        $type: "squareup.sub2.data.SubscriptionUsageTypeFeedEntry",
        subscriptionToken: undefined,
        subscriberEntity: undefined,
        active: undefined,
        usageTypes: undefined,
    };
}
export const SubscriptionUsageTypeFeedEntry = {
    $type: "squareup.sub2.data.SubscriptionUsageTypeFeedEntry",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscriptionToken !== undefined) {
            writer.uint32(10).string(message.subscriptionToken);
        }
        if (message.subscriberEntity !== undefined) {
            Entity.encode(message.subscriberEntity, writer.uint32(18).fork()).ldelim();
        }
        if (message.active !== undefined) {
            writer.uint32(24).bool(message.active);
        }
        if (message.usageTypes !== undefined) {
            UsageUnitTypes.encode(message.usageTypes, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionUsageTypeFeedEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscriptionToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriberEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.active = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.usageTypes = UsageUnitTypes.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionUsageTypeFeedEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionUsageTypeFeedEntry();
        message.subscriptionToken = object.subscriptionToken ?? undefined;
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.active = object.active ?? undefined;
        message.usageTypes = (object.usageTypes !== undefined && object.usageTypes !== null)
            ? UsageUnitTypes.fromPartial(object.usageTypes)
            : undefined;
        return message;
    },
};
function createBaseSubscriptionHistoryEvent() {
    return {
        $type: "squareup.sub2.data.SubscriptionHistoryEvent",
        subscription: undefined,
        timestamp: undefined,
        action: undefined,
        actor: undefined,
        actionDetail: undefined,
    };
}
export const SubscriptionHistoryEvent = {
    $type: "squareup.sub2.data.SubscriptionHistoryEvent",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscription !== undefined) {
            Subscription.encode(message.subscription, writer.uint32(10).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            DateTime.encode(message.timestamp, writer.uint32(18).fork()).ldelim();
        }
        if (message.action !== undefined) {
            writer.uint32(26).string(message.action);
        }
        if (message.actor !== undefined) {
            Entity.encode(message.actor, writer.uint32(34).fork()).ldelim();
        }
        if (message.actionDetail !== undefined) {
            writer.uint32(42).string(message.actionDetail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionHistoryEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscription = Subscription.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.timestamp = DateTime.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.action = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.actor = Entity.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.actionDetail = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionHistoryEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionHistoryEvent();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? Subscription.fromPartial(object.subscription)
            : undefined;
        message.timestamp = (object.timestamp !== undefined && object.timestamp !== null)
            ? DateTime.fromPartial(object.timestamp)
            : undefined;
        message.action = object.action ?? undefined;
        message.actor = (object.actor !== undefined && object.actor !== null)
            ? Entity.fromPartial(object.actor)
            : undefined;
        message.actionDetail = object.actionDetail ?? undefined;
        return message;
    },
};
function createBaseSubscriptionKey() {
    return {
        $type: "squareup.sub2.data.SubscriptionKey",
        subscriber: undefined,
        planToken: undefined,
        planBillingCycle: undefined,
        productOwner: undefined,
    };
}
export const SubscriptionKey = {
    $type: "squareup.sub2.data.SubscriptionKey",
    encode(message, writer = __m0.Writer.create()) {
        if (message.subscriber !== undefined) {
            Entity.encode(message.subscriber, writer.uint32(10).fork()).ldelim();
        }
        if (message.planToken !== undefined) {
            writer.uint32(18).string(message.planToken);
        }
        if (message.planBillingCycle !== undefined) {
            writer.uint32(32).int32(message.planBillingCycle);
        }
        if (message.productOwner !== undefined) {
            Entity.encode(message.productOwner, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscriber = Entity.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.planBillingCycle = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.productOwner = Entity.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SubscriptionKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionKey();
        message.subscriber = (object.subscriber !== undefined && object.subscriber !== null)
            ? Entity.fromPartial(object.subscriber)
            : undefined;
        message.planToken = object.planToken ?? undefined;
        message.planBillingCycle = object.planBillingCycle ?? undefined;
        message.productOwner = (object.productOwner !== undefined && object.productOwner !== null)
            ? Entity.fromPartial(object.productOwner)
            : undefined;
        return message;
    },
};
function createBaseUnavailableReason() {
    return { $type: "squareup.sub2.data.UnavailableReason", code: undefined, detail: undefined };
}
export const UnavailableReason = {
    $type: "squareup.sub2.data.UnavailableReason",
    encode(message, writer = __m0.Writer.create()) {
        if (message.code !== undefined) {
            writer.uint32(8).int32(message.code);
        }
        if (message.detail !== undefined) {
            writer.uint32(18).string(message.detail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnavailableReason();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.code = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.detail = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return UnavailableReason.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnavailableReason();
        message.code = object.code ?? undefined;
        message.detail = object.detail ?? undefined;
        return message;
    },
};
function createBaseLocalizedHeadlinePlanPricing() {
    return {
        $type: "squareup.sub2.data.LocalizedHeadlinePlanPricing",
        localizedAmount: undefined,
        localizedRecurrencyText: undefined,
    };
}
export const LocalizedHeadlinePlanPricing = {
    $type: "squareup.sub2.data.LocalizedHeadlinePlanPricing",
    encode(message, writer = __m0.Writer.create()) {
        if (message.localizedAmount !== undefined) {
            writer.uint32(10).string(message.localizedAmount);
        }
        if (message.localizedRecurrencyText !== undefined) {
            writer.uint32(18).string(message.localizedRecurrencyText);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocalizedHeadlinePlanPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.localizedAmount = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.localizedRecurrencyText = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return LocalizedHeadlinePlanPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLocalizedHeadlinePlanPricing();
        message.localizedAmount = object.localizedAmount ?? undefined;
        message.localizedRecurrencyText = object.localizedRecurrencyText ?? undefined;
        return message;
    },
};
function createBaseExternalPlan() {
    return {
        $type: "squareup.sub2.data.ExternalPlan",
        token: undefined,
        name: undefined,
        description: undefined,
        free: undefined,
        available: undefined,
        unavailableReasons: [],
        pricing: undefined,
        numFreeTrialDays: undefined,
        renewalCycle: undefined,
        estimatedCost: undefined,
        usageData: undefined,
        billingCycle: undefined,
        country: undefined,
        localizedHeadlinePlanPricing: undefined,
        headlineFeeRates: [],
        requiresExpirationDate: undefined,
        allowMissedPayments: undefined,
        subscriberCanCancel: undefined,
        subscriberCanPause: undefined,
    };
}
export const ExternalPlan = {
    $type: "squareup.sub2.data.ExternalPlan",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(26).string(message.description);
        }
        if (message.free !== undefined) {
            writer.uint32(32).bool(message.free);
        }
        if (message.available !== undefined) {
            writer.uint32(40).bool(message.available);
        }
        for (const v of message.unavailableReasons) {
            UnavailableReason.encode(v, writer.uint32(50).fork()).ldelim();
        }
        if (message.pricing !== undefined) {
            Pricing.encode(message.pricing, writer.uint32(58).fork()).ldelim();
        }
        if (message.numFreeTrialDays !== undefined) {
            writer.uint32(64).uint32(message.numFreeTrialDays);
        }
        if (message.renewalCycle !== undefined) {
            Duration.encode(message.renewalCycle, writer.uint32(74).fork()).ldelim();
        }
        if (message.estimatedCost !== undefined) {
            Money.encode(message.estimatedCost, writer.uint32(82).fork()).ldelim();
        }
        if (message.usageData !== undefined) {
            Usage.encode(message.usageData, writer.uint32(90).fork()).ldelim();
        }
        if (message.billingCycle !== undefined) {
            writer.uint32(96).int32(message.billingCycle);
        }
        if (message.country !== undefined) {
            writer.uint32(104).int32(message.country);
        }
        if (message.localizedHeadlinePlanPricing !== undefined) {
            LocalizedHeadlinePlanPricing.encode(message.localizedHeadlinePlanPricing, writer.uint32(114).fork()).ldelim();
        }
        for (const v of message.headlineFeeRates) {
            HeadlineFeeRate.encode(v, writer.uint32(122).fork()).ldelim();
        }
        if (message.requiresExpirationDate !== undefined) {
            writer.uint32(128).bool(message.requiresExpirationDate);
        }
        if (message.allowMissedPayments !== undefined) {
            writer.uint32(136).bool(message.allowMissedPayments);
        }
        if (message.subscriberCanCancel !== undefined) {
            writer.uint32(144).int32(message.subscriberCanCancel);
        }
        if (message.subscriberCanPause !== undefined) {
            writer.uint32(152).int32(message.subscriberCanPause);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExternalPlan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.free = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.available = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.unavailableReasons.push(UnavailableReason.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.pricing = Pricing.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.numFreeTrialDays = reader.uint32();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.renewalCycle = Duration.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.estimatedCost = Money.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.usageData = Usage.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.billingCycle = reader.int32();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.country = reader.int32();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.localizedHeadlinePlanPricing = LocalizedHeadlinePlanPricing.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.headlineFeeRates.push(HeadlineFeeRate.decode(reader, reader.uint32()));
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.requiresExpirationDate = reader.bool();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.allowMissedPayments = reader.bool();
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.subscriberCanCancel = reader.int32();
                    continue;
                case 19:
                    if (tag !== 152) {
                        break;
                    }
                    message.subscriberCanPause = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ExternalPlan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExternalPlan();
        message.token = object.token ?? undefined;
        message.name = object.name ?? undefined;
        message.description = object.description ?? undefined;
        message.free = object.free ?? undefined;
        message.available = object.available ?? undefined;
        message.unavailableReasons = object.unavailableReasons?.map((e) => UnavailableReason.fromPartial(e)) || [];
        message.pricing = (object.pricing !== undefined && object.pricing !== null)
            ? Pricing.fromPartial(object.pricing)
            : undefined;
        message.numFreeTrialDays = object.numFreeTrialDays ?? undefined;
        message.renewalCycle = (object.renewalCycle !== undefined && object.renewalCycle !== null)
            ? Duration.fromPartial(object.renewalCycle)
            : undefined;
        message.estimatedCost = (object.estimatedCost !== undefined && object.estimatedCost !== null)
            ? Money.fromPartial(object.estimatedCost)
            : undefined;
        message.usageData = (object.usageData !== undefined && object.usageData !== null)
            ? Usage.fromPartial(object.usageData)
            : undefined;
        message.billingCycle = object.billingCycle ?? undefined;
        message.country = object.country ?? undefined;
        message.localizedHeadlinePlanPricing =
            (object.localizedHeadlinePlanPricing !== undefined && object.localizedHeadlinePlanPricing !== null)
                ? LocalizedHeadlinePlanPricing.fromPartial(object.localizedHeadlinePlanPricing)
                : undefined;
        message.headlineFeeRates = object.headlineFeeRates?.map((e) => HeadlineFeeRate.fromPartial(e)) || [];
        message.requiresExpirationDate = object.requiresExpirationDate ?? undefined;
        message.allowMissedPayments = object.allowMissedPayments ?? undefined;
        message.subscriberCanCancel = object.subscriberCanCancel ?? undefined;
        message.subscriberCanPause = object.subscriberCanPause ?? undefined;
        return message;
    },
};
function createBaseBaseRate() {
    return {
        $type: "squareup.sub2.data.BaseRate",
        variableBasisPoints: undefined,
        fixedCents: undefined,
        constraints: [],
    };
}
export const BaseRate = {
    $type: "squareup.sub2.data.BaseRate",
    encode(message, writer = __m0.Writer.create()) {
        if (message.variableBasisPoints !== undefined) {
            writer.uint32(8).uint32(message.variableBasisPoints);
        }
        if (message.fixedCents !== undefined) {
            writer.uint32(16).uint32(message.fixedCents);
        }
        for (const v of message.constraints) {
            BaseRate_FeeRateConstraint.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseRate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.variableBasisPoints = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.fixedCents = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.constraints.push(BaseRate_FeeRateConstraint.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BaseRate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBaseRate();
        message.variableBasisPoints = object.variableBasisPoints ?? undefined;
        message.fixedCents = object.fixedCents ?? undefined;
        message.constraints = object.constraints?.map((e) => BaseRate_FeeRateConstraint.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBaseRate_FeeRateConstraint() {
    return { $type: "squareup.sub2.data.BaseRate.FeeRateConstraint", type: undefined, amountBaseUnit: undefined };
}
export const BaseRate_FeeRateConstraint = {
    $type: "squareup.sub2.data.BaseRate.FeeRateConstraint",
    encode(message, writer = __m0.Writer.create()) {
        if (message.type !== undefined) {
            writer.uint32(8).int32(message.type);
        }
        if (message.amountBaseUnit !== undefined) {
            writer.uint32(16).uint32(message.amountBaseUnit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBaseRate_FeeRateConstraint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.amountBaseUnit = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BaseRate_FeeRateConstraint.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBaseRate_FeeRateConstraint();
        message.type = object.type ?? undefined;
        message.amountBaseUnit = object.amountBaseUnit ?? undefined;
        return message;
    },
};
function createBaseHeadlineFeeRate() {
    return {
        $type: "squareup.sub2.data.HeadlineFeeRate",
        headlineRateName: undefined,
        localizedHeadlineRateName: undefined,
        currencyCode: undefined,
        baseRate: undefined,
        localizedBaseRateDisplay: undefined,
    };
}
export const HeadlineFeeRate = {
    $type: "squareup.sub2.data.HeadlineFeeRate",
    encode(message, writer = __m0.Writer.create()) {
        if (message.headlineRateName !== undefined) {
            writer.uint32(8).int32(message.headlineRateName);
        }
        if (message.localizedHeadlineRateName !== undefined) {
            writer.uint32(18).string(message.localizedHeadlineRateName);
        }
        if (message.currencyCode !== undefined) {
            writer.uint32(24).int32(message.currencyCode);
        }
        if (message.baseRate !== undefined) {
            BaseRate.encode(message.baseRate, writer.uint32(34).fork()).ldelim();
        }
        if (message.localizedBaseRateDisplay !== undefined) {
            writer.uint32(42).string(message.localizedBaseRateDisplay);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeadlineFeeRate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.headlineRateName = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.localizedHeadlineRateName = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.currencyCode = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.baseRate = BaseRate.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.localizedBaseRateDisplay = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return HeadlineFeeRate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeadlineFeeRate();
        message.headlineRateName = object.headlineRateName ?? undefined;
        message.localizedHeadlineRateName = object.localizedHeadlineRateName ?? undefined;
        message.currencyCode = object.currencyCode ?? undefined;
        message.baseRate = (object.baseRate !== undefined && object.baseRate !== null)
            ? BaseRate.fromPartial(object.baseRate)
            : undefined;
        message.localizedBaseRateDisplay = object.localizedBaseRateDisplay ?? undefined;
        return message;
    },
};
function createBasePlanGroup() {
    return {
        $type: "squareup.sub2.data.PlanGroup",
        token: undefined,
        plans: [],
        compareUrl: undefined,
        tiers: [],
        immediateDowngrades: [],
    };
}
export const PlanGroup = {
    $type: "squareup.sub2.data.PlanGroup",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        for (const v of message.plans) {
            ExternalPlan.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.compareUrl !== undefined) {
            writer.uint32(26).string(message.compareUrl);
        }
        for (const v of message.tiers) {
            PlanGroupTier.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.immediateDowngrades) {
            ImmediateDowngrade.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.plans.push(ExternalPlan.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.compareUrl = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.tiers.push(PlanGroupTier.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.immediateDowngrades.push(ImmediateDowngrade.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanGroup();
        message.token = object.token ?? undefined;
        message.plans = object.plans?.map((e) => ExternalPlan.fromPartial(e)) || [];
        message.compareUrl = object.compareUrl ?? undefined;
        message.tiers = object.tiers?.map((e) => PlanGroupTier.fromPartial(e)) || [];
        message.immediateDowngrades = object.immediateDowngrades?.map((e) => ImmediateDowngrade.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBundlePlanUsagePercentDiscount() {
    return {
        $type: "squareup.sub2.data.BundlePlanUsagePercentDiscount",
        unitType: undefined,
        percentDiscount: undefined,
    };
}
export const BundlePlanUsagePercentDiscount = {
    $type: "squareup.sub2.data.BundlePlanUsagePercentDiscount",
    encode(message, writer = __m0.Writer.create()) {
        if (message.unitType !== undefined) {
            writer.uint32(8).int32(message.unitType);
        }
        if (message.percentDiscount !== undefined) {
            writer.uint32(16).uint32(message.percentDiscount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundlePlanUsagePercentDiscount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.percentDiscount = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BundlePlanUsagePercentDiscount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundlePlanUsagePercentDiscount();
        message.unitType = object.unitType ?? undefined;
        message.percentDiscount = object.percentDiscount ?? undefined;
        return message;
    },
};
function createBaseBundlePlanUsageFixedDiscount() {
    return { $type: "squareup.sub2.data.BundlePlanUsageFixedDiscount", unitType: undefined, fixedDiscount: undefined };
}
export const BundlePlanUsageFixedDiscount = {
    $type: "squareup.sub2.data.BundlePlanUsageFixedDiscount",
    encode(message, writer = __m0.Writer.create()) {
        if (message.unitType !== undefined) {
            writer.uint32(8).int32(message.unitType);
        }
        if (message.fixedDiscount !== undefined) {
            Money.encode(message.fixedDiscount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundlePlanUsageFixedDiscount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unitType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fixedDiscount = Money.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BundlePlanUsageFixedDiscount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundlePlanUsageFixedDiscount();
        message.unitType = object.unitType ?? undefined;
        message.fixedDiscount = (object.fixedDiscount !== undefined && object.fixedDiscount !== null)
            ? Money.fromPartial(object.fixedDiscount)
            : undefined;
        return message;
    },
};
function createBasePercentDiscountBundlePriceAdjustment() {
    return {
        $type: "squareup.sub2.data.PercentDiscountBundlePriceAdjustment",
        discountedComponents: undefined,
        percent: undefined,
    };
}
export const PercentDiscountBundlePriceAdjustment = {
    $type: "squareup.sub2.data.PercentDiscountBundlePriceAdjustment",
    encode(message, writer = __m0.Writer.create()) {
        if (message.discountedComponents !== undefined) {
            writer.uint32(8).int32(message.discountedComponents);
        }
        if (message.percent !== undefined) {
            writer.uint32(16).uint32(message.percent);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePercentDiscountBundlePriceAdjustment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.discountedComponents = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.percent = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PercentDiscountBundlePriceAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePercentDiscountBundlePriceAdjustment();
        message.discountedComponents = object.discountedComponents ?? undefined;
        message.percent = object.percent ?? undefined;
        return message;
    },
};
function createBasePlanPercentDiscountBundlePriceAdjustment() {
    return {
        $type: "squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment",
        baseFeeDiscount: undefined,
        usageDiscounts: [],
        planToken: undefined,
    };
}
export const PlanPercentDiscountBundlePriceAdjustment = {
    $type: "squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment",
    encode(message, writer = __m0.Writer.create()) {
        if (message.baseFeeDiscount !== undefined) {
            writer.uint32(8).uint32(message.baseFeeDiscount);
        }
        for (const v of message.usageDiscounts) {
            BundlePlanUsagePercentDiscount.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.planToken !== undefined) {
            writer.uint32(26).string(message.planToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanPercentDiscountBundlePriceAdjustment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.baseFeeDiscount = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.usageDiscounts.push(BundlePlanUsagePercentDiscount.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanPercentDiscountBundlePriceAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanPercentDiscountBundlePriceAdjustment();
        message.baseFeeDiscount = object.baseFeeDiscount ?? undefined;
        message.usageDiscounts = object.usageDiscounts?.map((e) => BundlePlanUsagePercentDiscount.fromPartial(e)) || [];
        message.planToken = object.planToken ?? undefined;
        return message;
    },
};
function createBasePlanFixedDiscountBundlePriceAdjustment() {
    return {
        $type: "squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment",
        baseFeeDiscount: undefined,
        usageDiscounts: [],
        planToken: undefined,
    };
}
export const PlanFixedDiscountBundlePriceAdjustment = {
    $type: "squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment",
    encode(message, writer = __m0.Writer.create()) {
        if (message.baseFeeDiscount !== undefined) {
            Money.encode(message.baseFeeDiscount, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.usageDiscounts) {
            BundlePlanUsageFixedDiscount.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.planToken !== undefined) {
            writer.uint32(26).string(message.planToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanFixedDiscountBundlePriceAdjustment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.baseFeeDiscount = Money.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.usageDiscounts.push(BundlePlanUsageFixedDiscount.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanFixedDiscountBundlePriceAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanFixedDiscountBundlePriceAdjustment();
        message.baseFeeDiscount = (object.baseFeeDiscount !== undefined && object.baseFeeDiscount !== null)
            ? Money.fromPartial(object.baseFeeDiscount)
            : undefined;
        message.usageDiscounts = object.usageDiscounts?.map((e) => BundlePlanUsageFixedDiscount.fromPartial(e)) || [];
        message.planToken = object.planToken ?? undefined;
        return message;
    },
};
function createBaseBundlePriceAdjustment() {
    return {
        $type: "squareup.sub2.data.BundlePriceAdjustment",
        percentDiscountPriceAdjustment: undefined,
        planPercentDiscountPriceAdjustment: undefined,
        planFixedDiscountPriceAdjustment: undefined,
        label: undefined,
    };
}
export const BundlePriceAdjustment = {
    $type: "squareup.sub2.data.BundlePriceAdjustment",
    encode(message, writer = __m0.Writer.create()) {
        if (message.percentDiscountPriceAdjustment !== undefined) {
            PercentDiscountBundlePriceAdjustment.encode(message.percentDiscountPriceAdjustment, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.planPercentDiscountPriceAdjustment !== undefined) {
            PlanPercentDiscountBundlePriceAdjustment.encode(message.planPercentDiscountPriceAdjustment, writer.uint32(26).fork()).ldelim();
        }
        if (message.planFixedDiscountPriceAdjustment !== undefined) {
            PlanFixedDiscountBundlePriceAdjustment.encode(message.planFixedDiscountPriceAdjustment, writer.uint32(34).fork())
                .ldelim();
        }
        if (message.label !== undefined) {
            writer.uint32(18).string(message.label);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundlePriceAdjustment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.percentDiscountPriceAdjustment = PercentDiscountBundlePriceAdjustment.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.planPercentDiscountPriceAdjustment = PlanPercentDiscountBundlePriceAdjustment.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.planFixedDiscountPriceAdjustment = PlanFixedDiscountBundlePriceAdjustment.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BundlePriceAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundlePriceAdjustment();
        message.percentDiscountPriceAdjustment =
            (object.percentDiscountPriceAdjustment !== undefined && object.percentDiscountPriceAdjustment !== null)
                ? PercentDiscountBundlePriceAdjustment.fromPartial(object.percentDiscountPriceAdjustment)
                : undefined;
        message.planPercentDiscountPriceAdjustment =
            (object.planPercentDiscountPriceAdjustment !== undefined && object.planPercentDiscountPriceAdjustment !== null)
                ? PlanPercentDiscountBundlePriceAdjustment.fromPartial(object.planPercentDiscountPriceAdjustment)
                : undefined;
        message.planFixedDiscountPriceAdjustment =
            (object.planFixedDiscountPriceAdjustment !== undefined && object.planFixedDiscountPriceAdjustment !== null)
                ? PlanFixedDiscountBundlePriceAdjustment.fromPartial(object.planFixedDiscountPriceAdjustment)
                : undefined;
        message.label = object.label ?? undefined;
        return message;
    },
};
function createBaseBundlePricing() {
    return { $type: "squareup.sub2.data.BundlePricing", priceAdjustments: [] };
}
export const BundlePricing = {
    $type: "squareup.sub2.data.BundlePricing",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.priceAdjustments) {
            BundlePriceAdjustment.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundlePricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.priceAdjustments.push(BundlePriceAdjustment.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BundlePricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundlePricing();
        message.priceAdjustments = object.priceAdjustments?.map((e) => BundlePriceAdjustment.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBundle() {
    return {
        $type: "squareup.sub2.data.Bundle",
        token: undefined,
        subscriberEntity: undefined,
        bundleOfferingToken: undefined,
        bundleOfferingVersion: undefined,
        bundleOfferingName: undefined,
        status: undefined,
        startAt: undefined,
        endAt: undefined,
        pricing: [],
        expireAt: undefined,
    };
}
export const Bundle = {
    $type: "squareup.sub2.data.Bundle",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        if (message.subscriberEntity !== undefined) {
            Entity.encode(message.subscriberEntity, writer.uint32(18).fork()).ldelim();
        }
        if (message.bundleOfferingToken !== undefined) {
            writer.uint32(26).string(message.bundleOfferingToken);
        }
        if (message.bundleOfferingVersion !== undefined) {
            writer.uint32(32).uint32(message.bundleOfferingVersion);
        }
        if (message.bundleOfferingName !== undefined) {
            writer.uint32(42).string(message.bundleOfferingName);
        }
        if (message.status !== undefined) {
            writer.uint32(50).string(message.status);
        }
        if (message.startAt !== undefined) {
            DateTime.encode(message.startAt, writer.uint32(58).fork()).ldelim();
        }
        if (message.endAt !== undefined) {
            DateTime.encode(message.endAt, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.pricing) {
            BundlePricing.encode(v, writer.uint32(74).fork()).ldelim();
        }
        if (message.expireAt !== undefined) {
            DateTime.encode(message.expireAt, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriberEntity = Entity.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bundleOfferingToken = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.bundleOfferingVersion = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.bundleOfferingName = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.startAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.endAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.pricing.push(BundlePricing.decode(reader, reader.uint32()));
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.expireAt = DateTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Bundle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundle();
        message.token = object.token ?? undefined;
        message.subscriberEntity = (object.subscriberEntity !== undefined && object.subscriberEntity !== null)
            ? Entity.fromPartial(object.subscriberEntity)
            : undefined;
        message.bundleOfferingToken = object.bundleOfferingToken ?? undefined;
        message.bundleOfferingVersion = object.bundleOfferingVersion ?? undefined;
        message.bundleOfferingName = object.bundleOfferingName ?? undefined;
        message.status = object.status ?? undefined;
        message.startAt = (object.startAt !== undefined && object.startAt !== null)
            ? DateTime.fromPartial(object.startAt)
            : undefined;
        message.endAt = (object.endAt !== undefined && object.endAt !== null)
            ? DateTime.fromPartial(object.endAt)
            : undefined;
        message.pricing = object.pricing?.map((e) => BundlePricing.fromPartial(e)) || [];
        message.expireAt = (object.expireAt !== undefined && object.expireAt !== null)
            ? DateTime.fromPartial(object.expireAt)
            : undefined;
        return message;
    },
};
function createBaseBundleOffering() {
    return {
        $type: "squareup.sub2.data.BundleOffering",
        name: undefined,
        availabilityStatus: undefined,
        plans: [],
        freeTrialDuration: undefined,
        token: undefined,
        version: undefined,
        pricing: [],
        offeringDuration: undefined,
    };
}
export const BundleOffering = {
    $type: "squareup.sub2.data.BundleOffering",
    encode(message, writer = __m0.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.availabilityStatus !== undefined) {
            writer.uint32(16).int32(message.availabilityStatus);
        }
        for (const v of message.plans) {
            ExternalPlan.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.freeTrialDuration !== undefined) {
            Duration.encode(message.freeTrialDuration, writer.uint32(34).fork()).ldelim();
        }
        if (message.token !== undefined) {
            writer.uint32(42).string(message.token);
        }
        if (message.version !== undefined) {
            writer.uint32(48).uint32(message.version);
        }
        for (const v of message.pricing) {
            BundlePricing.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.offeringDuration !== undefined) {
            Duration.encode(message.offeringDuration, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBundleOffering();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.availabilityStatus = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.plans.push(ExternalPlan.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.freeTrialDuration = Duration.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.version = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.pricing.push(BundlePricing.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.offeringDuration = Duration.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BundleOffering.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBundleOffering();
        message.name = object.name ?? undefined;
        message.availabilityStatus = object.availabilityStatus ?? undefined;
        message.plans = object.plans?.map((e) => ExternalPlan.fromPartial(e)) || [];
        message.freeTrialDuration = (object.freeTrialDuration !== undefined && object.freeTrialDuration !== null)
            ? Duration.fromPartial(object.freeTrialDuration)
            : undefined;
        message.token = object.token ?? undefined;
        message.version = object.version ?? undefined;
        message.pricing = object.pricing?.map((e) => BundlePricing.fromPartial(e)) || [];
        message.offeringDuration = (object.offeringDuration !== undefined && object.offeringDuration !== null)
            ? Duration.fromPartial(object.offeringDuration)
            : undefined;
        return message;
    },
};
function createBaseFeedbackOption() {
    return {
        $type: "squareup.sub2.data.FeedbackOption",
        token: undefined,
        inputType: undefined,
        secondaryOptions: [],
        label: undefined,
    };
}
export const FeedbackOption = {
    $type: "squareup.sub2.data.FeedbackOption",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        if (message.inputType !== undefined) {
            writer.uint32(16).int32(message.inputType);
        }
        for (const v of message.secondaryOptions) {
            FeedbackOption.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.label !== undefined) {
            writer.uint32(34).string(message.label);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeedbackOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.inputType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.secondaryOptions.push(FeedbackOption.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeedbackOption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeedbackOption();
        message.token = object.token ?? undefined;
        message.inputType = object.inputType ?? undefined;
        message.secondaryOptions = object.secondaryOptions?.map((e) => FeedbackOption.fromPartial(e)) || [];
        message.label = object.label ?? undefined;
        return message;
    },
};
function createBaseFeedbackOptionList() {
    return { $type: "squareup.sub2.data.FeedbackOptionList", token: undefined, feedbackOptions: [] };
}
export const FeedbackOptionList = {
    $type: "squareup.sub2.data.FeedbackOptionList",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        for (const v of message.feedbackOptions) {
            FeedbackOption.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeedbackOptionList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.feedbackOptions.push(FeedbackOption.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeedbackOptionList.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeedbackOptionList();
        message.token = object.token ?? undefined;
        message.feedbackOptions = object.feedbackOptions?.map((e) => FeedbackOption.fromPartial(e)) || [];
        return message;
    },
};
function createBaseFeedback() {
    return { $type: "squareup.sub2.data.Feedback", feedbackOptionToken: undefined, text: undefined };
}
export const Feedback = {
    $type: "squareup.sub2.data.Feedback",
    encode(message, writer = __m0.Writer.create()) {
        if (message.feedbackOptionToken !== undefined) {
            writer.uint32(10).string(message.feedbackOptionToken);
        }
        if (message.text !== undefined) {
            writer.uint32(18).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeedback();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.feedbackOptionToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Feedback.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeedback();
        message.feedbackOptionToken = object.feedbackOptionToken ?? undefined;
        message.text = object.text ?? undefined;
        return message;
    },
};
function createBaseSuperPOSMode() {
    return { $type: "squareup.sub2.data.SuperPOSMode", engine: undefined, modeTemplateName: undefined };
}
export const SuperPOSMode = {
    $type: "squareup.sub2.data.SuperPOSMode",
    encode(message, writer = __m0.Writer.create()) {
        if (message.engine !== undefined) {
            writer.uint32(8).int32(message.engine);
        }
        if (message.modeTemplateName !== undefined) {
            writer.uint32(18).string(message.modeTemplateName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSuperPOSMode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.engine = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.modeTemplateName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SuperPOSMode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSuperPOSMode();
        message.engine = object.engine ?? undefined;
        message.modeTemplateName = object.modeTemplateName ?? undefined;
        return message;
    },
};
function createBaseActivationSource() {
    return { $type: "squareup.sub2.data.ActivationSource", nonPosSource: undefined, superPosMode: undefined };
}
export const ActivationSource = {
    $type: "squareup.sub2.data.ActivationSource",
    encode(message, writer = __m0.Writer.create()) {
        if (message.nonPosSource !== undefined) {
            writer.uint32(10).string(message.nonPosSource);
        }
        if (message.superPosMode !== undefined) {
            SuperPOSMode.encode(message.superPosMode, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActivationSource();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.nonPosSource = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.superPosMode = SuperPOSMode.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ActivationSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivationSource();
        message.nonPosSource = object.nonPosSource ?? undefined;
        message.superPosMode = (object.superPosMode !== undefined && object.superPosMode !== null)
            ? SuperPOSMode.fromPartial(object.superPosMode)
            : undefined;
        return message;
    },
};
function createBaseSquareOneEligibility() {
    return {
        $type: "squareup.sub2.data.SquareOneEligibility",
        eligible: undefined,
        eligiblePlanGroupToken: undefined,
        ineligibilityReason: undefined,
        flagName: undefined,
    };
}
export const SquareOneEligibility = {
    $type: "squareup.sub2.data.SquareOneEligibility",
    encode(message, writer = __m0.Writer.create()) {
        if (message.eligible !== undefined) {
            writer.uint32(8).bool(message.eligible);
        }
        if (message.eligiblePlanGroupToken !== undefined) {
            writer.uint32(18).string(message.eligiblePlanGroupToken);
        }
        if (message.ineligibilityReason !== undefined) {
            writer.uint32(24).int32(message.ineligibilityReason);
        }
        if (message.flagName !== undefined) {
            writer.uint32(34).string(message.flagName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSquareOneEligibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.eligible = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.eligiblePlanGroupToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.ineligibilityReason = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.flagName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SquareOneEligibility.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSquareOneEligibility();
        message.eligible = object.eligible ?? undefined;
        message.eligiblePlanGroupToken = object.eligiblePlanGroupToken ?? undefined;
        message.ineligibilityReason = object.ineligibilityReason ?? undefined;
        message.flagName = object.flagName ?? undefined;
        return message;
    },
};
function createBaseGaMigrationEligibility() {
    return {
        $type: "squareup.sub2.data.GaMigrationEligibility",
        eligible: undefined,
        ineligibilityReason: undefined,
        pendingMigrationPlanToken: undefined,
    };
}
export const GaMigrationEligibility = {
    $type: "squareup.sub2.data.GaMigrationEligibility",
    encode(message, writer = __m0.Writer.create()) {
        if (message.eligible !== undefined) {
            writer.uint32(8).bool(message.eligible);
        }
        if (message.ineligibilityReason !== undefined) {
            writer.uint32(16).int32(message.ineligibilityReason);
        }
        if (message.pendingMigrationPlanToken !== undefined) {
            writer.uint32(26).string(message.pendingMigrationPlanToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGaMigrationEligibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.eligible = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ineligibilityReason = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.pendingMigrationPlanToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return GaMigrationEligibility.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGaMigrationEligibility();
        message.eligible = object.eligible ?? undefined;
        message.ineligibilityReason = object.ineligibilityReason ?? undefined;
        message.pendingMigrationPlanToken = object.pendingMigrationPlanToken ?? undefined;
        return message;
    },
};
function createBaseEligibilityQualifier() {
    return {
        $type: "squareup.sub2.data.EligibilityQualifier",
        onboardingEntryPoint: undefined,
        superposVersion: undefined,
    };
}
export const EligibilityQualifier = {
    $type: "squareup.sub2.data.EligibilityQualifier",
    encode(message, writer = __m0.Writer.create()) {
        if (message.onboardingEntryPoint !== undefined) {
            writer.uint32(8).int32(message.onboardingEntryPoint);
        }
        if (message.superposVersion !== undefined) {
            Version.encode(message.superposVersion, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEligibilityQualifier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.onboardingEntryPoint = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.superposVersion = Version.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return EligibilityQualifier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEligibilityQualifier();
        message.onboardingEntryPoint = object.onboardingEntryPoint ?? undefined;
        message.superposVersion = (object.superposVersion !== undefined && object.superposVersion !== null)
            ? Version.fromPartial(object.superposVersion)
            : undefined;
        return message;
    },
};
function createBaseActiveTrial() {
    return {
        $type: "squareup.sub2.data.ActiveTrial",
        planToken: undefined,
        planTierToken: undefined,
        endAt: undefined,
        obligated: undefined,
    };
}
export const ActiveTrial = {
    $type: "squareup.sub2.data.ActiveTrial",
    encode(message, writer = __m0.Writer.create()) {
        if (message.planToken !== undefined) {
            writer.uint32(10).string(message.planToken);
        }
        if (message.planTierToken !== undefined) {
            writer.uint32(18).string(message.planTierToken);
        }
        if (message.endAt !== undefined) {
            DateTime.encode(message.endAt, writer.uint32(26).fork()).ldelim();
        }
        if (message.obligated !== undefined) {
            writer.uint32(32).bool(message.obligated);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActiveTrial();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planTierToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.endAt = DateTime.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.obligated = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ActiveTrial.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActiveTrial();
        message.planToken = object.planToken ?? undefined;
        message.planTierToken = object.planTierToken ?? undefined;
        message.endAt = (object.endAt !== undefined && object.endAt !== null)
            ? DateTime.fromPartial(object.endAt)
            : undefined;
        message.obligated = object.obligated ?? undefined;
        return message;
    },
};
function createBaseAvailableTrial() {
    return {
        $type: "squareup.sub2.data.AvailableTrial",
        planToken: undefined,
        planTierToken: undefined,
        days: undefined,
    };
}
export const AvailableTrial = {
    $type: "squareup.sub2.data.AvailableTrial",
    encode(message, writer = __m0.Writer.create()) {
        if (message.planToken !== undefined) {
            writer.uint32(10).string(message.planToken);
        }
        if (message.planTierToken !== undefined) {
            writer.uint32(18).string(message.planTierToken);
        }
        if (message.days !== undefined) {
            writer.uint32(24).uint32(message.days);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAvailableTrial();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planTierToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.days = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return AvailableTrial.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAvailableTrial();
        message.planToken = object.planToken ?? undefined;
        message.planTierToken = object.planTierToken ?? undefined;
        message.days = object.days ?? undefined;
        return message;
    },
};
function createBaseConsumedTrial() {
    return {
        $type: "squareup.sub2.data.ConsumedTrial",
        planToken: undefined,
        planTierToken: undefined,
        endAt: undefined,
    };
}
export const ConsumedTrial = {
    $type: "squareup.sub2.data.ConsumedTrial",
    encode(message, writer = __m0.Writer.create()) {
        if (message.planToken !== undefined) {
            writer.uint32(10).string(message.planToken);
        }
        if (message.planTierToken !== undefined) {
            writer.uint32(18).string(message.planTierToken);
        }
        if (message.endAt !== undefined) {
            DateTime.encode(message.endAt, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConsumedTrial();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planTierToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.endAt = DateTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ConsumedTrial.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConsumedTrial();
        message.planToken = object.planToken ?? undefined;
        message.planTierToken = object.planTierToken ?? undefined;
        message.endAt = (object.endAt !== undefined && object.endAt !== null)
            ? DateTime.fromPartial(object.endAt)
            : undefined;
        return message;
    },
};
function createBasePlanGroupTier() {
    return {
        $type: "squareup.sub2.data.PlanGroupTier",
        token: undefined,
        planTokens: [],
        numFreeTrialDays: undefined,
        localizedTierName: undefined,
    };
}
export const PlanGroupTier = {
    $type: "squareup.sub2.data.PlanGroupTier",
    encode(message, writer = __m0.Writer.create()) {
        if (message.token !== undefined) {
            writer.uint32(10).string(message.token);
        }
        for (const v of message.planTokens) {
            writer.uint32(18).string(v);
        }
        if (message.numFreeTrialDays !== undefined) {
            writer.uint32(24).uint32(message.numFreeTrialDays);
        }
        if (message.localizedTierName !== undefined) {
            writer.uint32(34).string(message.localizedTierName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanGroupTier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.planTokens.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.numFreeTrialDays = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.localizedTierName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanGroupTier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanGroupTier();
        message.token = object.token ?? undefined;
        message.planTokens = object.planTokens?.map((e) => e) || [];
        message.numFreeTrialDays = object.numFreeTrialDays ?? undefined;
        message.localizedTierName = object.localizedTierName ?? undefined;
        return message;
    },
};
function createBaseImmediateDowngrade() {
    return { $type: "squareup.sub2.data.ImmediateDowngrade", fromPlanToken: undefined, toPlanToken: undefined };
}
export const ImmediateDowngrade = {
    $type: "squareup.sub2.data.ImmediateDowngrade",
    encode(message, writer = __m0.Writer.create()) {
        if (message.fromPlanToken !== undefined) {
            writer.uint32(10).string(message.fromPlanToken);
        }
        if (message.toPlanToken !== undefined) {
            writer.uint32(18).string(message.toPlanToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImmediateDowngrade();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.fromPlanToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.toPlanToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return ImmediateDowngrade.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImmediateDowngrade();
        message.fromPlanToken = object.fromPlanToken ?? undefined;
        message.toPlanToken = object.toPlanToken ?? undefined;
        return message;
    },
};
function createBasePlanPromotionData() {
    return {
        $type: "squareup.sub2.data.PlanPromotionData",
        planToken: undefined,
        promotionalPricing: undefined,
        promotionalPricingDuration: undefined,
        freeTrialDuration: undefined,
    };
}
export const PlanPromotionData = {
    $type: "squareup.sub2.data.PlanPromotionData",
    encode(message, writer = __m0.Writer.create()) {
        if (message.planToken !== undefined) {
            writer.uint32(10).string(message.planToken);
        }
        if (message.promotionalPricing !== undefined) {
            Pricing.encode(message.promotionalPricing, writer.uint32(18).fork()).ldelim();
        }
        if (message.promotionalPricingDuration !== undefined) {
            Duration.encode(message.promotionalPricingDuration, writer.uint32(26).fork()).ldelim();
        }
        if (message.freeTrialDuration !== undefined) {
            Duration.encode(message.freeTrialDuration, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlanPromotionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.promotionalPricing = Pricing.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.promotionalPricingDuration = Duration.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.freeTrialDuration = Duration.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return PlanPromotionData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlanPromotionData();
        message.planToken = object.planToken ?? undefined;
        message.promotionalPricing = (object.promotionalPricing !== undefined && object.promotionalPricing !== null)
            ? Pricing.fromPartial(object.promotionalPricing)
            : undefined;
        message.promotionalPricingDuration =
            (object.promotionalPricingDuration !== undefined && object.promotionalPricingDuration !== null)
                ? Duration.fromPartial(object.promotionalPricingDuration)
                : undefined;
        message.freeTrialDuration = (object.freeTrialDuration !== undefined && object.freeTrialDuration !== null)
            ? Duration.fromPartial(object.freeTrialDuration)
            : undefined;
        return message;
    },
};
function createBaseMigrationPromotionData() {
    return { $type: "squareup.sub2.data.MigrationPromotionData", planPromotions: [] };
}
export const MigrationPromotionData = {
    $type: "squareup.sub2.data.MigrationPromotionData",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.planPromotions) {
            PlanPromotionData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMigrationPromotionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.planPromotions.push(PlanPromotionData.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return MigrationPromotionData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMigrationPromotionData();
        message.planPromotions = object.planPromotions?.map((e) => PlanPromotionData.fromPartial(e)) || [];
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
const registerLong = () => {
    const backup = __m0.util.Long;
    __m0.util.Long = Long;
    __m0.configure();
    return () => {
        __m0.util.Long = backup;
        __m0.configure();
    };
};
